import * as echarts from 'echarts';

export const map = echarts.registerMap('china', {
    "type": "FeatureCollection",
    "features": [{
        "id": "710000",
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@°Ü¯Û", "@@ƛĴÕƊÉɼģºðʀ\\ƎsÆNŌÔĚänÜƤɊĂǀĆĴĤǊŨxĚĮǂƺòƌâÔ®ĮXŦţƸZûÐƕƑGđ¨ĭMó·ęcëƝɉlÝƯֹÅŃ^Ó·śŃǋƏďíåɛGɉ¿IċããF¥ĘWǬÏĶñÄ", "@@\\p|WoYG¿¥Ij@", "@@¡@V^RqBbAnTXeQr©C", "@@ÆEEkWqë I"]
            ],
            "encodeOffsets": [
                [
                    [122886, 24033],
                    [123335, 22980],
                    [122375, 24193],
                    [122518, 24117],
                    [124427, 22618]
                ]
            ]
        },
        "properties": {
            "cp": [121.509062, 25.044332],
            "name": "台湾",
            "childNum": 5
        }
    }, {
        "id": "130000",
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@\\aM`Ç½ÓnUKĜēs¤­©yrý§uģcJ»eIP]ªrºc_ħ²G¼s`jÎŸnüsÂľP", "@@U`Ts¿mÄ", "@@FOhđ©OiÃ`ww^ÌkÑH«ƇǤŗĺtFu{Z}Ö@U´ʚLg®¯Oı°Ãw ^VbÉsmAê]]w§RRl£ŭuwNÁ`ÇFēÝčȻuT¡Ĺ¯Õ¯sŗő£YªhVƍ£ƅnëYNgq¼ś¿µı²UºÝUąąŖóxV@tƯJ]eR¾fe|rHA|h~Ėƍl§ÏjVë` ØoÅbbx³^zÃĶ¶Sj®AyÂhðk`«PËµEFÛ¬Y¨Ļrõqi¼Wi°§Ð±²°`[À|ĠO@ÆxO\\ta\\p_Zõ^û{ġȧXýĪÓjùÎRb^Î»j{íděYfíÙTymńŵōHim½éŅ­aVcř§ax¹XŻácWU£ôãºQ¨÷Ñws¥qEHÙ|šYQoŕÇyáĂ£MÃ°oťÊP¡mWO¡v{ôvîēÜISpÌhp¨ jdeŔQÖjX³àĈ[n`Yp@UcM`RKhEbpŞlNut®EtqnsÁgAiúoHqCXhfgu~ÏWP½¢G^}¯ÅīGCÑ^ãziMáļMTÃƘrMc|O_¯Ŏ´|morDkO\\mĆJfl@cĢ¬¢aĦtRıÒXòë¬WP{ŵǫƝīÛ÷ąV×qƥV¿aȉd³BqPBmaËđŻģmÅ®V¹d^KKonYg¯XhqaLdu¥Ípǅ¡KąÅkĝęěhq}HyÃ]¹ǧ£Í÷¿qágPmoei¤o^á¾ZEY^Ný{nOl±Í@Mċèk§daNaÇį¿]øRiiñEūiǱàUtėGyl}ÓM}jpEC~¡FtoQiHkk{ILgĽxqÈƋÄdeVDJj£J|ÅdzÂFt~KŨ¸IÆv|¢r}èonb}`RÎÄn°ÒdÞ²^®lnÐèĄlðÓ×]ªÆ}LiĂ±Ö`^°Ç¶p®đDcŋ`ZÔ¶êqvFÆN®ĆTH®¦O¾IbÐã´BĐɢŴÆíȦpĐÞXR·nndO¤OÀĈƒ­QgµFo|gȒęSWb©osx|hYhgŃfmÖĩnºTÌSp¢dYĤ¶UĈjlǐpäðëx³kÛfw²Xjz~ÂqbTÑěŨ@|oMzv¢ZrÃVw¬ŧĖ¸f°ÐTªqs{S¯r æÝl¼ÖĞ ǆiGĘJ¼lr}~K¨ŸƐÌWö¼Þ°nÞoĦL|C~D©|q]SvKÑcwpÏÏĿćènĪWlĄkT}¬Tp~®Hgd˒ĺBVtEÀ¢ôPĎƗè@~kü\\rÊĔÖæW_§¼F´©òDòjYÈrbĞāøŀG{ƀ|¦ðrb|ÀH`pʞkvGpuARhÞÆǶgĘTǼƹS£¨¡ù³ŘÍ]¿ÂyôEP xX¶¹ÜO¡gÚ¡IwÃé¦ÅBÏ|Ç°N«úmH¯âbęU~xĈbȒ{^xÖlD¸dɂ~"]
            ],
            "encodeOffsets": [
                [
                    [120023, 41045],
                    [121616, 39981],
                    [122102, 42307]
                ]
            ]
        },
        "properties": {
            "cp": [114.502461, 38.045474],
            "name": "河北",
            "childNum": 3
        }
    }, {
        "id": "140000",
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@ħÜ_ªlìwGkÛÃǏokćiµVZģ¡coTSË¹ĪmnÕńehZg{gtwªpXaĚThȑp{¶Eh®RćƑP¿£PmcªaJyý{ýȥoÅîɡųAďä³aÏJ½¥PG­ąSM­sWz½µÛYÓŖgxoOkĒCo­Èµ]¯_²ÕjāK~©ÅØ^ÔkïçămÏk]­±cÝ¯ÑÃmQÍ~_apm~ç¡qu{JÅŧ·Ls}EyÁÆcI{¤IiCfUcƌÃp§]ě«vD@¡SÀµMÅwuYY¡DbÑc¡h×]nkoQdaMç~eDÛtT©±@¥ù@É¡ZcW|WqOJmĩl«ħşvOÓ«IqăV¥D[mI~Ó¢cehiÍ]Ɠ~ĥqX·eƷn±}v[ěďŕ]_œ`¹§ÕōIo©b­s^}Ét±ū«³p£ÿ¥WÑxçÁ«h×u×¥ř¾dÒ{ºvĴÎêÌɊ²¶ü¨|ÞƸµȲLLúÉƎ¤ϊęĔV`_bªS^|dzY|dz¥pZbÆ£¶ÒK}tĦÔņƠPYznÍvX¶Ěn ĠÔzý¦ª÷ÑĸÙUȌ¸dòÜJð´ìúNM¬XZ´¤ŊǸ_tldI{¦ƀðĠȤ¥NehXnYGR° ƬDj¬¸|CĞKqºfƐiĺ©ª~ĆOQª ¤@ìǦɌ²æBÊTĞHƘÁĪËĖĴŞȀÆÿȄlŤĒötÎ½î¼ĨXh|ªM¤ÐzÞĩÒSrao³"],
            "encodeOffsets": [
                [117016, 41452]
            ]
        },
        "properties": {
            "cp": [112.549248, 37.857014],
            "name": "山西",
            "childNum": 1
        }
    }, {
        "id": "150000",
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@ǪƫÌÛMĂ[`ÕCn}¶Vcês¯PqFB|S³C|kñHdiÄ¥sŉÅPóÑÑE^ÅPpy_YtShQ·aHwsOnŉÃs©iqjUSiº]ïW«gW¡ARëśĳĘů`çõh]y»ǃǛҤxÒm~zf}pf|ÜroÈzrKÈĵSƧż؜Ġu~è¬vîS¼ĂhĖMÈÄw\\fŦ°W ¢¾luŸDw\\Ŗĝ", "@@GVu»Aylßí¹ãe]Eāò³C¹ð¾²iÒAdkò^P²CǜңǄ z¼g^èöŰ_Ĳĕê}gÁnUI«m]jvV¼euhwqAaW_µj»çjioQR¹ēÃßt@r³[ÛlćË^ÍÉáGOUÛOB±XkÅ¹£k|e]olkVÍ¼ÕqtaÏõjgÁ£§U^RLËnX°ÇBz^~wfvypV ¯ƫĉ˭ȫƗŷɿÿĿƑ˃ĝÿÃǃßËőó©ǐȍŒĖM×ÍEyxþp]ÉvïèvƀnÂĴÖ@V~Ĉ³MEĸÅĖtējyÄDXÄxGQuv_i¦aBçw˛wD©{tāmQ{EJ§KPśƘƿ¥@sCTÉ}ɃwƇy±gÑ}T[÷kÐç¦«SÒ¥¸ëBX½HáÅµÀğtSÝÂa[ƣ°¯¦Pï¡]£ġÒk®G²èQ°óMq}EóƐÇ\\@áügQÍu¥FTÕ¿Jû]|mvāÎYua^WoÀa·­ząÒot×¶CLƗi¯¤mƎHǊ¤îìɾŊìTdåwsRÖgĒųúÍġäÕ}Q¶¿A[¡{d×uQAMxVvMOmăl«ct[wº_ÇÊjbÂ£ĦS_éQZ_lwgOiýe`YYJq¥IÁǳ£ÙË[ÕªuƏ³ÍTs·bÁĽäė[b[ŗfãcn¥îC¿÷µ[ŏÀQ­ōĉm¿Á^£mJVmL[{Ï_£F¥Ö{ŹA}×Wu©ÅaųĳƳhB{·TQqÙIķËZđ©Yc|M¡LeVUóK_QWk_ĥ¿ãZ»X\\ĴuUèlG®ěłTĠğDŃGÆÍz]±ŭ©Å]ÅÐ}UË¥©TċïxgckfWgi\\ÏĒ¥HkµEë{»ÏetcG±ahUiñiWsɁ·cCÕk]wȑ|ća}wVaĚá G°ùnM¬¯{ÈÐÆA¥ÄêJxÙ¢hP¢ÛºµwWOóFÁz^ÀŗÎú´§¢T¤ǻƺSėǵhÝÅQgvBHouʝl_o¿Ga{ïq{¥|ſĿHĂ÷aĝÇqZñiñC³ª»E`¨åXēÕqÉû[l}ç@čƘóO¿¡FUsAʽīccocÇS}£IS~ălkĩXçmĈŀÐoÐdxÒuL^T{r@¢ÍĝKén£kQyÅõËXŷƏL§~}kq»IHėǅjĝ»ÑÞoå°qTt|r©ÏS¯·eŨĕx«È[eM¿yupN~¹ÏyN£{©għWí»Í¾səšǅ_ÃĀɗ±ąĳĉʍŌŷSÉA±åǥɋ@ë£R©ąP©}ĹªƏj¹erLDĝ·{i«ƫC½ÉshVzGS|úþXgp{ÁX¿ć{ƱȏñZáĔyoÁhA}ŅĆfdŉ_¹Y°ėǩÑ¡H¯¶oMQqð¡Ë|Ñ`ƭŁX½·óÛxğįÅcQs«tȋǅFù^it«Č¯[hAi©á¥ÇĚ×l|¹y¯Kȝqgů{ñǙµïċĹzŚȭ¶¡oŽäÕG\\ÄT¿Òõr¯LguÏYęRƩɷŌO\\İÐ¢æ^Ŋ ĲȶȆbÜGĝ¬¿ĚVĎgª^íu½jÿĕęjık@Ľ]ėl¥ËĭûÁėéV©±ćn©­ȇÍq¯½YÃÔŉÉNÑÅÝy¹NqáʅDǡËñ­ƁYÅy̱os§ȋµʽǘǏƬɱàưN¢ƔÊuľýľώȪƺɂļxZĈ}ÌŉŪĺœĭFЛĽ̅ȣͽÒŵìƩÇϋÿȮǡŏçƑůĕ~Ç¼ȳÐUfdIxÿ\\G zâɏÙOº·pqy£@qþ@Ǟ˽IBäƣzsÂZÁàĻdñ°ŕzéØűzșCìDȐĴĺf®Àľưø@ɜÖÞKĊŇƄ§͑těï͡VAġÑÑ»d³öǍÝXĉĕÖ{þĉu¸ËʅğU̎éhɹƆ̗̮ȘǊ֥ड़ࡰţાíϲäʮW¬®ҌeרūȠkɬɻ̼ãüfƠSצɩςåȈHϚÎKǳͲOðÏȆƘ¼CϚǚ࢚˼ФÔ¤ƌĞ̪Qʤ´¼mȠJˀƲÀɠmɆǄĜƠ´ǠN~ʢĜ¶ƌĆĘźʆȬ˪ĚĒ¸ĞGȖƴƀj`ĢçĶāàŃºēĢĖćYÀŎüôQÐÂŎŞǆŞêƖoˆDĤÕºÑǘÛˤ³̀gńƘĔÀ^ªƂ`ªt¾äƚêĦĀ¼ÐĔǎ¨Ȕ»͠^ˮÊȦƤøxRrŜH¤¸ÂxDÄ|ø˂˜ƮÐ¬ɚwɲFjĔ²Äw°ǆdÀÉ_ĸdîàŎjÊêTĞªŌŜWÈ|tqĢUB~´°ÎFCU¼pĀēƄN¦¾O¶łKĊOjĚj´ĜYp{¦SĚÍ\\T×ªV÷Ší¨ÅDK°ßtŇĔK¨ǵÂcḷ̌ĚǣȄĽFlġUĵŇȣFʉɁMğįʏƶɷØŭOǽ«ƽū¹Ʊő̝Ȩ§ȞʘĖiɜɶʦ}¨֪ࠜ̀ƇǬ¹ǨE˦ĥªÔêFxúQEr´Wrh¤Ɛ \\talĈDJÜ|[Pll̚¸ƎGú´P¬W¦^¦H]prRn|or¾wLVnÇIujkmon£cX^Bh`¥V¦U¤¸}xRj[^xN[~ªxQ[`ªHÆÂExx^wN¶Ê|¨ìMrdYpoRzNyÀDs~bcfÌ`L¾n|¾T°c¨È¢ar¤`[|òDŞĔöxElÖdHÀI`Ď\\Àì~ÆR¼tf¦^¢ķ¶eÐÚMptgjɡČÅyġLûŇV®ÄÈƀĎ°P|ªVVªj¬ĚÒêp¬E|ŬÂ_~¼rƐK f{ĘFĒƌXưăkÃĄ}nµo×q£ç­kX{uĩ«āíÓUŅÝVUŌ]Ť¥lyň[oi{¦LĸĦ^ôâJ¨^UZðÚĒL¿Ìf£K£ʺoqNwğc`uetOj×°KJ±qÆġmĚŗos¬qehqsuH{¸kH¡ÊRǪÇƌbȆ¢´äÜ¢NìÉʖ¦â©Ɨؗ"]
            ],
            "encodeOffsets": [
                [
                    [128500, 52752],
                    [127089, 51784]
                ]
            ]
        },
        "properties": {
            "cp": [111.670801, 40.818311],
            "name": "内蒙古",
            "childNum": 2
        }
    }, {
        "id": "210000",
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@L@@s]", "@@MnNm", "@@dc", "@@eÀC@b", "@@fXwkbrÄ`qg", "@@^jtWQ", "@@~ Y[c", "@@I`ĖN^_¿ZÁM", "@@Ïxǌ{q_×^Gigp", "@@iX¶BY", "@@YZ", "@@L_yG`b", "@@^WqCTZ", "@@\\[§t|]", "@@m`p[", "@@@é^BntaÊU]x ¯ÄPĲ­°hʙK³VÕ@Y~|EvĹsÇ¦­L^pÃ²ŸÒG Ël]xxÄ_fT¤Ď¤cPC¨¸TVjbgH²sdÎdHt`B²¬GJję¶[ÐhjeXdlwhðSČ¦ªVÊÏÆZÆŶ®²^ÎyÅHńĚDMħĜŁH­kçvV[ĳ¼WYÀäĦ`XlR`ôLUVfK¢{NZdĒªYĸÌÚJRr¸SA|ƴgŴĴÆbvªØX~źB|¦ÕE¤Ð`\\|KUnnI]¤ÀÂĊnŎR®Ő¿¶\\ÀøíDm¦ÎbŨabaĘ\\ľãÂ¸atÎSƐ´©v\\ÖÚÌǴ¤Â¨JKrZ_ZfjþhPkx`YRIjJcVf~sCN¤ EhæmsHy¨SðÑÌ\\\\ĐRÊwS¥fqŒßýáĞÙÉÖ[^¯ǤŲê´\\¦¬ĆPM¯£»uïpùzExanµyoluqe¦W^£ÊL}ñrkqWňûPUP¡ôJoo·U}£[·¨@XĸDXm­ÛÝºGUCÁª½{íĂ^cjk¶Ã[q¤LÉö³cux«|Zd²BWÇ®Yß½ve±ÃCý£W{Ú^q^sÑ·¨ËMr¹·C¥GDrí@wÕKţÃ«V·i}xËÍ÷i©ĝɝǡ]{c±OW³Ya±_ç©HĕoƫŇqr³Lys[ñ³¯OSďOMisZ±ÅFC¥Pq{Ã[Pg}\\¿ghćOk^ĩÃXaĕËĥM­oEqqZûěŉ³F¦oĵhÕP{¯~TÍlªNßYÐ{Ps{ÃVUeĎwk±ŉVÓ½ŽJãÇÇ»Jm°dhcÀffdF~ĀeĖd`sx² ®EĦ¦dQÂd^~ăÔH¦\\LKpĄVez¤NP ǹÓRÆąJSh­a[¦´ÂghwmBÐ¨źhI|VV|p] Â¼èNä¶ÜBÖ¼L`¼bØæKVpoúNZÞÒKxpw|ÊEMnzEQIZZNBčÚFÜçmĩWĪñtÞĵÇñZ«uD±|ƏlǗw·±PmÍada CLǑkùó¡³Ï«QaċÏOÃ¥ÕđQȥċƭy³ÁA"]
            ],
            "encodeOffsets": [
                [
                    [123686, 41445],
                    [126019, 40435],
                    [124393, 40128],
                    [126117, 39963],
                    [125322, 40140],
                    [126686, 40700],
                    [126041, 40374],
                    [125584, 40168],
                    [125509, 40217],
                    [125453, 40165],
                    [125362, 40214],
                    [125280, 40291],
                    [125774, 39997],
                    [125976, 40496],
                    [125822, 39993],
                    [122731, 40949]
                ]
            ]
        },
        "properties": {
            "cp": [123.429096, 41.796767],
            "name": "辽宁",
            "childNum": 16
        }
    }, {
        "id": "220000",
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@ñr½ÉKāGÁ¤ia ÉÈ¹`\\xs¬dĆkNnuNUwNx¶c¸|\\¢GªóĄ~RãÖÎĢùđŴÕhQxtcæëSɽŉíëǉ£ƍG£nj°KƘµDsØÑpyĆ¸®¿bXp]vbÍZuĂ{n^IüÀSÖ¦EvRÎûh@â[ƏÈô~FNr¯ôçR±­HÑlĢ^¤¢OðætxsŒ]ÞÁTĠs¶¿âÆGW¾ìA¦·TÑ¬è¥ÏÐJ¨¼ÒÖ¼ƦɄxÊ~StD@Ă¼Ŵ¡jlºWvÐzƦZÐ²CH AxiukdGgetqmcÛ£Ozy¥cE}|¾cZk¿uŐã[oxGikfeäT@SUwpiÚFM©£è^Ú`@v¶eňf heP¶täOlÃUgÞzŸU`l}ÔÆUvØ_Ō¬Öi^ĉi§²ÃB~¡ĈÚEgc|DC_Ȧm²rBx¼MÔ¦ŮdĨÃâYxƘDVÇĺĿg¿cwÅ\\¹¥Yĭl¤OvLjM_a W`zļMž·\\swqÝSAqŚĳ¯°kRē°wx^ĐkǂÒ\\]nrĂ}²ĊŲÒøãh·M{yMzysěnĒġV·°G³¼XÀ¤¹i´o¤ŃÈ`ÌǲÄUĞd\\iÖmÈBĤÜɲDEh LG¾ƀÄ¾{WaYÍÈĢĘÔRîĐj}ÇccjoUb½{h§Ǿ{KƖµÎ÷GĄØŜçưÌs«lyiē«`å§H¥Ae^§GK}iã\\c]v©ģZmÃ|[M}ģTɟĵÂÂ`ÀçmFK¥ÚíÁbX³ÌQÒHof{]ept·GŋĜYünĎųVY^ydõkÅZW«WUa~U·SbwGçǑiW^qFuNĝ·EwUtW·Ýďæ©PuqEzwAVXRãQ`­©GYYhcUGorBd}ģÉb¡·µMicF«Yƅ»é\\ɹ~ǙG³mØ©BšuT§Ĥ½¢Ã_Ã½L¡ûsT\\rke\\PnwAKy}ywdSefµ]UhĿD@mÿvaÙNSkCuncÿ`lWėVâ¦÷~^fÏ~vwHCį`xqT­­lW«ï¸skmßEGqd¯R©Ý¯¯S\\cZ¹iűƏCuƍÓXoR}M^o£R}oªU­FuuXHlEÅÏ©¤ßgXþ¤D²ÄufàÀ­XXÈ±Ac{Yw¬dvõ´KÊ£\\rµÄlidā]|î©¾DÂVH¹Þ®ÜWnCķ W§@\\¸~¤Vp¸póIO¢VOŇürXql~òÉK]¤¥Xrfkvzpm¶bwyFoúvð¼¤ N°ąO¥«³[éǣű]°Õ\\ÚÊĝôîŇÔaâBYlďQ[ Ë[ïÒ¥RI|`j]P"],
            "encodeOffsets": [
                [126831, 44503]
            ]
        },
        "properties": {
            "cp": [125.3245, 43.886841],
            "name": "吉林",
            "childNum": 1
        }
    }, {
        "id": "230000",
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@UµNÿ¥īèçHÍøƕ¶Lǽ|g¨|a¾pVidd~ÈiíďÓQġėÇZÎXb½|ſÃH½KFgɱCģÛÇAnjÕc[VĝǱÃËÇ_ £ń³pj£º¿»WH´¯U¸đĢmtĜyzzNN|g¸÷äűÑ±ĉā~mq^[ǁÑďlw]¯xQĔ¯l°řĴrBÞTxr[tŽ¸ĻN_yX`biNKuP£kZĮ¦[ºxÆÀdhĹŀUÈƗCwáZħÄŭcÓ¥»NAw±qȥnD`{ChdÙFć}¢A±Äj¨]ĊÕjŋ«×`VuÓÅ~_kŷVÝyhVkÄãPsOµfgeŇµf@u_Ù ÙcªNªÙEojVxT@ãSefjlwH\\pŏäÀvlY½d{F~¦dyz¤PÜndsrhfHcvlwjF£G±DÏƥYyÏu¹XikĿ¦ÏqƗǀOŜ¨LI|FRĂn sª|C˜zxAè¥bfudTrFWÁ¹Am|ĔĕsķÆF´N}ćUÕ@Áĳſmuçuð^ÊýowFzØÎĕNőǏȎôªÌŒǄàĀÄ˄ĞŀƒʀĀƘŸˮȬƬĊ°Uzouxe]}AyÈW¯ÌmKQ]Īºif¸ÄX|sZt|½ÚUÎ lk^p{f¤lºlÆW A²PVÜPHÊâ]ÎĈÌÜk´\\@qàsĔÄQºpRij¼èi`¶bXrBgxfv»uUi^v~J¬mVp´£´VWrnP½ì¢BX¬hðX¹^TjVriªjtŊÄmtPGx¸bgRsT`ZozÆO]ÒFôÒOÆŊvÅpcGêsx´DR{AEOr°x|íb³Wm~DVjºéNNËÜ˛ɶ­GxŷCSt}]ûōSmtuÇÃĕNāg»íT«u}ç½BĵÞʣ¥ëÊ¡MÛ³ãȅ¡ƋaǩÈÉQG¢·lG|tvgrrf«ptęŘnÅĢrI²¯LiØsPf_vĠdxM prʹL¤¤eËÀđKïÙVY§]Ióáĥ]ķK¥j|pŇ\\kzţ¦šnņäÔVĂîĪ¬|vW®l¤èØrxm¶ă~lÄƯĄ̈́öȄEÔ¤ØQĄĄ»ƢjȦOǺ¨ìSŖÆƬyQv`cwZSÌ®ü±Ǆ]ŀç¬B¬©ńzƺŷɄeeOĨSfm ĊƀP̎ēz©ĊÄÕÊmgÇsJ¥ƔŊśæÎÑqv¿íUOµªÂnĦÁ_½ä@êí£P}Ġ[@gġ}gɊ×ûÏWXá¢užƻÌsNÍ½ƎÁ§čŐAēeL³àydl¦ĘVçŁpśǆĽĺſÊQíÜçÛġÔsĕ¬Ǹ¯YßċġHµ ¡eå`ļrĉŘóƢFìĎWøxÊkƈdƬv|I|·©NqńRŀ¤éeŊŀàŀU²ŕƀBQ£Ď}L¹Îk@©ĈuǰųǨÚ§ƈnTËÇéƟÊcfčŤ^XmHĊĕË«W·ċëx³ǔķÐċJāwİ_ĸȀ^ôWr­°oú¬ĦŨK~ȰCĐ´Ƕ£fNÎèâw¢XnŮeÂÆĶ¾¾xäLĴĘlļO¤ÒĨA¢Êɚ¨®ØCÔ ŬGƠƦYĜĘÜƬDJg_ͥœ@čŅĻA¶¯@wÎqC½Ĉ»NăëKďÍQÙƫ[«ÃígßÔÇOÝáWñuZ¯ĥŕā¡ÑķJu¤E å¯°WKÉ±_d_}}vyõu¬ï¹ÓU±½@gÏ¿rÃ½DgCdµ°MFYxw¿CG£Rƛ½Õ{]L§{qqą¿BÇƻğëܭǊË|c²}Fµ}ÙRsÓpg±QNqǫŋRwŕnéÑÉK«SeYRŋ@{¤SJ}D Ûǖ֍]gr¡µŷjqWÛham³~S«Ü[", "@@ƨĶTLÇyqpÇÛqe{~oyen}s`qiXGù]Ëp½©lÉÁp]Þñ´FĂ^fäîºkàz¼BUv¬D"]
            ],
            "encodeOffsets": [
                [
                    [134456, 44547],
                    [127123, 51780]
                ]
            ]
        },
        "properties": {
            "cp": [126.642464, 45.756967],
            "name": "黑龙江",
            "childNum": 2
        }
    }, {
        "id": "320000",
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@Õg^vÁbnÀ`Jnĝ¬òM¶ĘTÖŒbe¦¦{¸ZâćNp©Hp|`mjhSEb\\afv`sz^lkljÄtg¤D­¾X¿À|ĐiZȀåB·î}GL¢õcßjayBFµÏC^ĭcÙt¿sğH]j{s©HM¢QnDÀ©DaÜÞ·jgàiDbPufjDk`dPOîhw¡ĥ¥GP²ĐobºrYî¶aHŢ´ ]´rılw³r_{£DB_Ûdåuk|Ũ¯F Cºyr{XFye³Þċ¿ÂkĭB¿MvÛpm`rÚã@Ę¹hågËÖƿxnlč¶Åì½Ot¾dJlVJĂǀŞqvnO^JZż·Q}êÍÅmµÒ]ƍ¦Dq}¬R^èĂ´ŀĻĊIÔtĲyQŐĠMNtR®òLhĚs©»}OÓGZz¶A\\jĨFäOĤHYJvÞHNiÜaĎÉnFQlNM¤B´ĄNöɂtpŬdZÅglmuÇUšŞÚb¤uŃJŴu»¹ĄlȖħŴw̌ŵ²ǹǠ͛hĭłƕrçü±Yrřl¥i`ã__¢ćSÅr[Çq^ùzWmOĈaŐÝɞï²ʯʊáĘĳĒǭPħ͍ôƋÄÄÍīçÛɈǥ£­ÛmY`ó£Z«§°Ó³QafusNıǅ_k}¢m[ÝóDµ¡RLčiXyÅNïă¡¸iĔÏNÌķoıdōîåŤûHcs}~Ûwbù¹£¦ÓCtOPrE^ÒogĉIµÛÅʹK¤½phMú`mR¸¦PƚgÉLRs`£¯ãhD¨|³¤C"],
            "encodeOffsets": [
                [121451, 32518]
            ]
        },
        "properties": {
            "cp": [118.767413, 32.041544],
            "name": "江苏",
            "childNum": 1
        }
    }, {
        "id": "330000",
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@jX^n", "@@sfdM", "@@qP\\xz[_i", "@@o\\VzRZ}mECy", "@@R¢FX}°[m]", "@@Cb\\}", "@@e|v\\laus", "@@v~s{", "@@QxÂF©}", "@@¹nvÞs©m", "@@rQgYIh", "@@bi«ZX", "@@p[}ILd", "@@À¿|", "@@¹dnb", "@@rS}[Kl", "@@g~h}", "@@FlCk", "@@ůTG°ĄLHm°UF", "@@OdRe", "@@v[u\\", "@@FjâL~wyoo~sµLZ", "@@¬e¹aH", "@@\\nÔ¡q]L³ë\\ÿ®QÌ", "@@ÊA­©]ª", "@@Kxv{­", "@@@hlIk_", "@@pWcrxp", "@@Md|_iA", "@@¢X£½z\\ðpN", "@@hlÜ[LykAvyfw^E ", "@@fp¤MusH", "@@®_ma~LÁ¬`", "@@@°¡mÛGĕ¨§Ianá[ýƤjfæÐNäGp", "@@iMt\\", "@@Zc[b", "@@X®±GrÆ°Zæĉm", "@@Z~dOSo|A¿qZv", "@@@`EN£p", "@@|s", "@@@nDi", "@@na£¾uYL¯QªmĉÅdMgÇjcº«ę¬­K­´B«Âącoċ\\xK`cįŧ«®á[~ıxu·ÅKsËÉc¢Ù\\ĭƛëbf¹­ģSĜkáƉÔ­ĈZB{aMµfzŉfÓÔŹŁƋǝÊĉ{ğč±g³ne{ç­ií´S¬\\ßðK¦w\\iqªĭiAuA­µ_W¥ƣO\\lċĢttC¨£t`PZäuXßBsĻyekOđġĵHuXBµ]×­­\\°®¬F¢¾pµ¼kŘó¬Wät¸|@L¨¸µrºù³Ù~§WIZW®±Ð¨ÒÉx`²pĜrOògtÁZ{üÙ[|ûKwsPlU[}¦Rvn`hsª^nQ´ĘRWb_ rtČFIÖkĦPJ¶ÖÀÖJĈĄTĚòC ²@PúØz©Pî¢£CÈÚĒ±hŖl¬â~nm¨f©iļ«mntqÒTÜÄjL®EÌFª²iÊxØ¨IÈhhst[Ôx}dtüGæţŔïĬaĸpMËÐjē¢·ðĄÆMzjWKĎ¢Q¶À_ê_@ıi«pZgf¤Nrq]§ĂN®«H±yƳí¾×ŊďŀĐÏŴǝĂíÀBŖÕªÁŐTFqĉ¯³ËCĕģi¨hÜ·ñt»¯Ï", "@@ºwZRkĕWK "]
            ],
            "encodeOffsets": [
                [
                    [125785, 31436],
                    [125729, 31431],
                    [125513, 31380],
                    [125329, 30690],
                    [125223, 30438],
                    [125115, 30114],
                    [124815, 29155],
                    [124419, 28746],
                    [124095, 28635],
                    [124005, 28609],
                    [125000, 30713],
                    [125111, 30698],
                    [125078, 30682],
                    [125150, 30684],
                    [124014, 28103],
                    [125008, 31331],
                    [125411, 31468],
                    [125329, 31479],
                    [125369, 31139],
                    [125626, 30916],
                    [125417, 30956],
                    [125254, 30976],
                    [125199, 30997],
                    [125095, 31058],
                    [125083, 30915],
                    [124885, 31015],
                    [125218, 30798],
                    [124867, 30838],
                    [124755, 30788],
                    [124802, 30809],
                    [125267, 30657],
                    [125218, 30578],
                    [125200, 30562],
                    [125192, 30787],
                    [124968, 30474],
                    [125167, 30396],
                    [125115, 30363],
                    [124955, 29879],
                    [124714, 29781],
                    [124762, 29462],
                    [124325, 28754],
                    [124863, 30077],
                    [125366, 31477]
                ]
            ]
        },
        "properties": {
            "cp": [120.153576, 30.287459],
            "name": "浙江",
            "childNum": 43
        }
    }, {
        "id": "340000",
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@^iuLV\\", "@@e©Edh", "@@´CE¶zAXêeödK¡~H¸íæAȽd{ďÅÀ½W®£ChÃsikkly]_teu[bFaTign{]GqªoĈMYá|·¥f¥őaSÕėNµñĞ«Im_m¿Âa]uĜp Z_§{Cäg¤°r[_YjÆOdý[I[á·¥Q_nùgL¾mzˆDÜÆ¶ĊJhpc¹O]iŠ]¥ jtsggDÑ¡w×jÉ©±EFË­KiÛÃÕYvsm¬njĻª§emná}k«ŕgđ²ÙDÇ¤í¡ªOy×Où±@DñSęćăÕIÕ¿IµĥOlJÕÍRÍ|JìĻÒåyķrĕq§ÄĩsWÆßF¶X®¿mwRIÞfßoG³¾©uyHį{Ɓħ¯AFnuPÍÔzVdàôº^Ðæd´oG¤{S¬ćxã}ŧ×Kǥĩ«ÕOEÐ·ÖdÖsƘÑ¨[Û^Xr¢¼§xvÄÆµ`K§ tÒ´Cvlo¸fzŨð¾NY´ı~ÉĔēßúLÃÃ_ÈÏ|]ÂÏHlg`ben¾¢pUh~ƴĖ¶_r sĄ~cƈ]|r c~`¼{À{ȒiJjz`îÀT¥Û³]u}fïQl{skloNdjäËzDvčoQďHI¦rbrHĖ~BmlNRaĥTX\\{fÁKÁ®TLÂÄMtÊgĀDĄXƔvDcÎJbt[¤D@®hh~kt°ǾzÖ@¾ªdbYhüóV´ŮŒ¨Üc±r@J|àuYÇÔG·ĚąĐlŪÚpSJ¨ĸLvÞcPæķŨ®mÐálsgd×mQ¨ųÆ©Þ¤IÎs°KZpĄ|XwWdĎµmkǀwÌÕæhºgBĝâqÙĊzÖgņtÀÁĂÆáhEz|WzqD¹°Eŧl{ævÜcA`¤C`|´qxĲkq^³³GšµbíZ¹qpa±ď OH¦Ħx¢gPícOl_iCveaOjChß¸iÝbÛªCC¿mRV§¢A|tbkĜEÀtîm^g´fÄ"]
            ],
            "encodeOffsets": [
                [
                    [121722, 32278],
                    [119475, 30423],
                    [121606, 33646]
                ]
            ]
        },
        "properties": {
            "cp": [117.283042, 31.86119],
            "name": "安徽",
            "childNum": 3
        }
    }, {
        "id": "350000",
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@zht´}[", "@@aj^~ĆGå", "@@edHse", "@@@vPGsyQ", "@@sBzddW[O", "@@S¨Qy", "@@NVucW", "@@qptB@q", "@@¸[iu", "@@Q\\pD[_", "@@jSwUappI", "@@eXª~", "@@AjvFoo", "@@fT_Çí\\v|ba¦jZÆy|®", "@@IjLg", "@@wJIx«¼AoNe{M¥", "@@K±¡ÓČ~N¾", "@@k¡¹Eh~c®uDqZì¡I~Māe£bN¨gZý¡a±Öcp©PhI¢QqÇGj|¥U g[Ky¬ŏv@OptÉEF\\@ åA¬V{XģĐBycpě¼³Ăp·¤¥ohqqÚ¡ŅLs^Ã¡§qlÀhH¨MCe»åÇGD¥zPO£čÙkJA¼ßėuĕeûÒiÁŧS[¡Uûŗ½ùěcÝ§SùĩąSWó«íęACµeRåǃRCÒÇZÍ¢ź±^dlstjD¸ZpuÔâÃH¾oLUêÃÔjjēò´ĄWƛ^Ñ¥Ħ@ÇòmOw¡õyJyD}¢ďÑÈġfZda©º²z£NjD°Ötj¶¬ZSÎ~¾c°¶ÐmxO¸¢Pl´SL|¥AȪĖMņĲg®áIJČĒü` QF¬h|ĂJ@zµ |ê³È ¸UÖŬŬÀCtrĸr]ðM¤ĶĲHtÏ AĬkvsq^aÎbvdfÊòSD´Z^xPsĂrvƞŀjJd×ŘÉ ®AÎ¦ĤdxĆqAZRÀMźnĊ»İÐZ YXæJyĊ²·¶q§·K@·{sXãô«lŗ¶»o½E¡­«¢±¨Y®Ø¶^AvWĶGĒĢPlzfļtàAvWYãO_¤sD§ssČġ[kƤPX¦`¶®BBvĪjv©jx[L¥àï[F¼ÍË»ğV`«Ip}ccÅĥZEãoP´B@D¸m±z«Ƴ¿å³BRØ¶Wlâþäą`]Z£Tc ĹGµ¶Hm@_©k¾xĨôȉðX«½đCIbćqK³ÁÄš¬OAwã»aLŉËĥW[ÂGIÂNxĳ¤D¢îĎÎB§°_JGs¥E@¤ućPåcuMuw¢BI¿]zG¹guĮI"]
            ],
            "encodeOffsets": [
                [
                    [123250, 27563],
                    [122541, 27268],
                    [123020, 27189],
                    [122916, 27125],
                    [122887, 26845],
                    [122808, 26762],
                    [122568, 25912],
                    [122778, 26197],
                    [122515, 26757],
                    [122816, 26587],
                    [123388, 27005],
                    [122450, 26243],
                    [122578, 25962],
                    [121255, 25103],
                    [120987, 24903],
                    [122339, 25802],
                    [121042, 25093],
                    [122439, 26024]
                ]
            ]
        },
        "properties": {
            "cp": [119.306239, 26.075302],
            "name": "福建",
            "childNum": 18
        }
    }, {
        "id": "360000",
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@ÖP¬ǦĪØLŨä~Ĉw«|TH£pc³Ïå¹]ĉđxe{ÎÓvOEm°BƂĨİ|Gvz½ª´HàpeJÝQxnÀW­EµàXÅĪt¨ÃĖrÄwÀFÎ|Ă¡WÕ¸cf¥XaęST±m[r«_gmQu~¥V\\OkxtL E¢Ú^~ýØkbēqoě±_Êw§Ñ²ÏƟė¼mĉŹ¿NQYBąrwģcÍ¥B­ŗÊcØiIƝĿuqtāwO]³YCñTeÉcaubÍ]trluīBÐGsĵıN£ï^ķqsq¿DūūVÕ·´Ç{éĈýÿOER_đûIċâJh­ŅıNȩĕB¦K{Tk³¡OP·wnµÏd¯}½TÍ«YiµÕsC¯iM¤­¦¯P|ÿUHvhe¥oFTuõ\\OSsMòđƇiaºćXĊĵà·çhƃ÷Ç{ígu^đgm[ÙxiIN¶Õ»lđÕwZSÆv©_ÈëJbVkĔVÀ¤P¾ºÈMÖxlò~ªÚàGĂ¢B±ÌKyñ`w²¹·`gsÙfIěxŕeykpudjuTfb·hh¿Jd[\\LáƔĨƐAĈepÀÂMD~ņªe^\\^§ý©j×cZØ¨zdÒa¶lÒJìõ`oz÷@¤uŞ¸´ôęöY¼HČƶajlÞƩ¥éZ[|h}^U  ¥pĄžƦO lt¸Æ Q\\aÆ|CnÂOjt­ĚĤdÈF`¶@Ðë ¦ōÒ¨SêvHĢÛ@[ÆQoxHW[ŰîÀt¦Ǆ~NĠ¢lĄtZoCƞÔºCxrpČNpj¢{f_Y`_eq®Aot`@oDXfkp¨|s¬\\DÄSfè©Hn¬^DhÆyøJhØxĢĀLÊƠPżċĄwĮ¶"],
            "encodeOffsets": [
                [118923, 30536]
            ]
        },
        "properties": {
            "cp": [115.892151, 28.676493],
            "name": "江西",
            "childNum": 1
        }
    }, {
        "id": "370000",
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@Xjd]mE", "@@itnq", "@@Dl@k", "@@TGw", "@@K¬U", "@@Wd`c", "@@PtMs", "@@LnXlc", "@@ppVu]Qn", "@@cdzAU_", "@@udRhnCE", "@@oIpP", "@@M{ĿčwbxƨîKÎMĮ]ZF½Y]â£ph¶¨râøÀÎǨ¤^ºÄGz~grĚĜlĞÆLĆǆ¢Îo¦cvKbgr°WhmZp L]LºcUÆ­nżĤÌĒbAnrOA´ȊcÀbƦUØrĆUÜøĬƞŶǬĴóò_A̈«ªdÎÉnb²ĦhņBĖįĦåXćì@L¯´ywƕCéÃµė ƿ¸lµZæyj|BíÂKNNnoƈfÈMZwnŐNàúÄsTJULîVjǎ¾ĒØDz²XPn±ŴPè¸ŔLƔÜƺ_TüÃĤBBċÈöA´faM¨{«M`¶d¡ôÖ°mȰBÔjj´PM|c^d¤u¤Û´ä«ƢfPk¶Môl]Lb}su^ke{lCMrDÇ­]NÑFsmoõľHyGă{{çrnÓEƕZGª¹Fj¢ÿ©}ÌCǷë¡ąuhÛ¡^KxC`C\\bÅxì²ĝÝ¿_NīCȽĿåB¥¢·IŖÕy\\¹kxÃ£ČáKµË¤ÁçFQ¡KtŵƋ]CgÏAùSedcÚźuYfyMmhUWpSyGwMPqŀÁ¼zK¶G­Y§Ë@´śÇµƕBm@IogZ¯uTMx}CVKï{éƵP_K«pÛÙqċtkkù]gTğwoɁsMõ³ăAN£MRkmEÊčÛbMjÝGuIZGPģãħE[iµBEuDPÔ~ª¼ęt]ûG§¡QMsğNPŏįzs£Ug{đJĿļā³]ç«Qr~¥CƎÑ^n¶ÆéÎR~Ż¸YI] PumŝrƿIā[xeÇ³L¯v¯s¬ÁY~}ťuŁgƋpÝĄ_ņī¶ÏSR´ÁP~¿Cyċßdwk´SsX|t`Ä ÈðAªìÎT°¦Dda^lĎDĶÚY°`ĪŴǒàŠv\\ebZHŖR¬ŢƱùęOÑM­³FÛaj"]
            ],
            "encodeOffsets": [
                [
                    [123806, 39303],
                    [123821, 39266],
                    [123742, 39256],
                    [123702, 39203],
                    [123649, 39066],
                    [123847, 38933],
                    [123580, 38839],
                    [123894, 37288],
                    [123043, 36624],
                    [123344, 38676],
                    [123522, 38857],
                    [123628, 38858],
                    [118267, 36772]
                ]
            ]
        },
        "properties": {
            "cp": [117.000923, 36.675807],
            "name": "山东",
            "childNum": 13
        }
    }, {
        "id": "410000",
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@dXD}~Hgq~ÔN~zkĘHVsǲßjŬŢ`Pûàl¢\\ÀEhİgÞē X¼`khÍLùµP³swIÓzeŠĠð´E®ÚPtºIŊÊºL«šŕQGYfa[şußǑĩų_Z¯ĵÙčC]kbc¥CS¯ëÍB©ïÇÃ_{sWTt³xlàcČzÀD}ÂOQ³ÐTĬµƑÐ¿ŸghłŦv~}ÂZ«¤lPÇ£ªÝŴÅR§ØnhctâknÏ­ľŹUÓÝdKuķI§oTũÙďkęĆH¸Ó\\Ä¿PcnS{wBIvÉĽ[GqµuŇôYgûZca©@½Õǽys¯}lgg@­C\\£asIdÍuCQñ[L±ęk·ţb¨©kK»KC²òGKmĨS`UQnk}AGēsqaJ¥ĐGRĎpCuÌy ã iMcplk|tRkðev~^´¦ÜSí¿_iyjI|ȑ|¿_»d}q^{Ƈdă}tqµ`ŷé£©V¡om½ZÙÏÁRD|JOÈpÀRsI{ùÓjuµ{t}uËRivGçJFjµåkWê´MÂHewixGw½Yŷpµú³XU½ġyłåkÚwZX·l¢Á¢KzOÎÎjc¼htoDHr|­J½}JZ_¯iPq{tę½ĕ¦Zpĵø«kQĹ¤]MÛfaQpě±ǽ¾]u­Fu÷nčÄ¯ADp}AjmcEÇaª³o³ÆÍSƇĈÙDIzçñİ^KNiÞñ[aA²zzÌ÷D|[íÄ³gfÕÞd®|`Ć~oĠƑô³ŊD×°¯CsøÂ«ìUMhTº¨¸ǝêWÔDruÂÇZ£ĆPZW~ØØv¬gèÂÒw¦X¤Ā´oŬ¬²Ês~]®tªapŎJ¨Öº_ŔfŐ\\Đ\\Ĝu~m²Ƹ¸fWĦrƔ}Î^gjdfÔ¡J}\\n C¦þWxªJRÔŠu¬ĨĨmFdM{\\d\\YÊ¢ú@@¦ª²SÜsC}fNècbpRmlØ^gd¢aÒ¢CZZxvÆ¶N¿¢T@uC¬^ĊðÄn|lIlXhun[", "@@hzUq"]
            ],
            "encodeOffsets": [
                [
                    [116744, 37216],
                    [116480, 33048]
                ]
            ]
        },
        "properties": {
            "cp": [113.665412, 34.757975],
            "name": "河南",
            "childNum": 2
        }
    }, {
        "id": "420000",
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@ASd", "@@ls{d", "@@¾«}{ra®pîÃ\\{øCËyyB±b\\òÝjKL ]ĎĽÌJyÚCƈćÎT´Å´pb©ÈdFin~BCo°BĎÃømv®E^vǾ½Ĝ²RobÜeN^ĺ£R¬lĶ÷YoĖ¥Ě¾|sOr°jY`~I¾®I{GqpCgyl{£ÍÍyPLÂ¡¡¸kWxYlÙæŁĢz¾V´W¶ùŸo¾ZHxjwfxGNÁ³Xéæl¶EièIH ujÌQ~v|sv¶Ôi|ú¢FhQsğ¦SiŠBgÐE^ÁÐ{čnOÂÈUÎóĔÊēĲ}Z³½Mŧïeyp·uk³DsÑ¨L¶_ÅuÃ¨w»¡WqÜ]\\Ò§tƗcÕ¸ÕFÏǝĉăxŻČƟOKÉġÿ×wg÷IÅzCg]m«ªGeçÃTC«[t§{loWeC@ps_Bp­rf_``Z|ei¡oċMqow¹DƝÓDYpûsYkıǃ}s¥ç³[§cY§HK«Qy]¢wwö¸ïx¼ņ¾Xv®ÇÀµRĠÐHM±cÏdƒǍũȅȷ±DSyúĝ£ŤĀàtÖÿï[îb\\}pĭÉI±Ñy¿³x¯No|¹HÏÛmjúË~TuęjCöAwě¬Rđl¯ Ñb­ŇTĿ_[IčĄʿnM¦ğ\\É[T·k¹©oĕ@A¾wya¥Y\\¥Âaz¯ãÁ¡k¥ne£ÛwE©Êō¶˓uoj_U¡cF¹­[WvP©whuÕyBF`RqJUw\\i¡{jEPïÿ½fćQÑÀQ{°fLÔ~wXgītêÝ¾ĺHd³fJd]HJ²EoU¥HhwQsƐ»Xmg±çve]DmÍPoCc¾_hhøYrŊU¶eD°Č_N~øĹĚ·`z]Äþp¼äÌQv\\rCé¾TnkžŐÚÜa¼ÝƆĢ¶ÛodĔňÐ¢JqPb ¾|J¾fXƐîĨ_Z¯À}úƲN_ĒÄ^ĈaŐyp»CÇÄKñL³ġM²wrIÒŭxjb[n«øæà ^²­h¯ÚŐªÞ¸Y²ĒVø}Ā^İ´LÚm¥ÀJÞ{JVųÞŃx×sxxƈē ģMřÚðòIfĊŒ\\Ʈ±ŒdÊ§ĘDvČ_Àæ~Dċ´A®µ¨ØLV¦êHÒ¤"]
            ],
            "encodeOffsets": [
                [
                    [113712, 34000],
                    [115612, 30507],
                    [113649, 34054]
                ]
            ]
        },
        "properties": {
            "cp": [114.298572, 30.584355],
            "name": "湖北",
            "childNum": 3
        }
    }, {
        "id": "430000",
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@nFZw", "@@ãÆá½ÔXrCOËRïÿĩ­TooQyÓ[ŅBE¬ÎÓXaį§Ã¸G °ITxpúxÚĳ¥ÏĢ¾edÄ©ĸGàGhM¤Â_U}Ċ}¢pczfþg¤ÇôAV", "@@ȴÚĖÁĐiOĜ«BxDõĚivSÌ}iùÜnÐºG{p°M°yÂÒzJ²Ì ÂcXëöüiáÿñőĞ¤ùTz²CȆȸǎŪƑÐc°dPÎğË¶[È½u¯½WM¡­ÉB·rínZÒ `¨GA¾\\pēXhÃRC­üWGġuTé§ŎÑ©êLM³}_EÇģc®ęisÁPDmÅ{b[RÅs·kPŽƥóRoOV~]{g\\êYƪ¦kÝbiċƵGZ»Ěõó·³vŝ£ø@pyö_ëIkÑµbcÑ§y×dYØªiþUjŅ³C}ÁN»hĻħƏâƓKA·³CQ±µ§¿AUƑ¹AtćOwD]JUÖgk¯b£ylZFËÑ±H­}EbóľA¡»Ku¦·³åş¥ùBD^{ÌC´­¦ŷJ£^[ª¿ğ|ƅN skóā¹¿ï]ă~÷O§­@Vm¡Qđ¦¢Ĥ{ºjÔª¥nf´~Õo×ÛąGû¥cÑ[Z¶ŨĪ²SÊǔƐƀAÚŌ¦QØ¼rŭ­«}NÏürÊ¬mjr@ĘrTW ­SsdHzƓ^ÇÂyUi¯DÅYlŹu{hT}mĉ¹¥ěDÿë©ıÓ[Oº£¥ótł¹MÕƪ`PDiÛU¾ÅâìUñBÈ£ýhedy¡oċ`pfmjP~kZaZsÐd°wj§@Ĵ®w~^kÀÅKvNmX\\¨aŃqvíó¿F¤¡@ũÑVw}S@j}¾«pĂrªg àÀ²NJ¶¶DôK|^ª°LX¾ŴäPĪ±£EXd^¶ĲÞÜ~u¸ǔMRhsRe`ÄofIÔ\\Ø  ićymnú¨cj ¢»GČìƊÿÐ¨XeĈĀ¾Oð Fi ¢|[jVxrIQ_EzAN¦zLU`cªxOTu RLÄªpUĪȴ^ŎµªÉFxÜf¤ºgĲèy°Áb[¦Zb¦z½xBĖ@ªpºjS´rVźOd©ʪiĎăJP`"]
            ],
            "encodeOffsets": [
                [
                    [115640, 30489],
                    [112577, 27316],
                    [114113, 30649]
                ]
            ]
        },
        "properties": {
            "cp": [112.982279, 28.19409],
            "name": "湖南",
            "childNum": 3
        }
    }, {
        "id": "440000",
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@QdAsa", "@@lxDRm", "@@sbhNLo", "@@Ă ý", "@@WltOY[", "@@Kr]S", "@@e~AS}", "@@I|Mym", "@@Û³LS²Q", "@@nvºBë¥cÕº", "@@zdÛJm", "@@°³", "@@a yAª¸ËJIxØ@ĀHÉÕZofoo", "@@sŗÃÔėAƁZÄ ~°ČPºb", "@@¶ÝÌvmĞh¹Ĺ", "@@HdSjĒ¢D}waru«ZqadY{K", "@@el\\LqqO", "@@~rMmX", "@@f^E", "@@øPªoj÷ÍÝħXČx°Q¨ıXJp", "@@gÇƳmxatfu", "@@EÆC½", "@@¸B_¶ekWvSivc}p}Ăº¾NĎyj¦Èm th_®Ä}»âUzLË²Aā¡ßH©Ùñ}wkNÕ¹ÇO½¿£ēUlaUìIÇª`uTÅxYĒÖ¼kÖµMjJÚwn\\hĒv]îh|ÈƄøèg¸Ķß ĉĈWb¹ƀdéĘNTtP[öSvrCZaGubo´ŖÒÇĐ~¡zCIözx¢PnÈñ @ĥÒ¦]ƜX³ăĔñiiÄÓVépKG½ÄÓávYoC·sitiaÀyŧÎ¡ÈYDÑům}ý|m[węõĉZÅxUO}÷N¹³ĉo_qtăqwµŁYÙǝŕ¹tïÛUÃ¯mRCºĭ|µÕÊK½Rē ó]GªęAxNqSF|ām¡diď×YïYWªŉOeÚtĐ«zđ¹TāúEáÎÁWwíHcòßÎſ¿Çdğ·ùT×Çūʄ¡XgWÀǇğ·¿ÃOj YÇ÷Sğ³kzőõmĝ[³¡VÙæÅöMÌ³¹pÁaËýý©D©ÜJŹƕģGą¤{ÙūÇO²«BƱéAÒĥ¡«BhlmtÃPµyU¯ucd·w_bŝcīímGOGBȅŹãĻFŷŽŕ@Óoo¿ē±ß}}ÓF÷tĲWÈCőâUâǙIğŉ©IĳE×Á³AĥDĈ±ÌÜÓĨ£L]ĈÙƺZǾĆĖMĸĤfÎĵlŨnÈĐtFFĤêk¶^k°f¶g}®Faf`vXŲxl¦ÔÁ²¬Ð¦pqÊÌ²iXØRDÎ}Ä@ZĠsx®AR~®ETtĄZƈfŠŠHâÒÐAµ\\S¸^wĖkRzalŜ|E¨ÈNĀňZTpBh£\\ĎƀuXĖtKL¶G|»ĺEļĞ~ÜĢÛĊrOÙîvd]n¬VÊĜ°RÖpMƀ¬HbwEÀ©\\¤]ŸI®¥D³|Ë]CúAŠ¦æ´¥¸Lv¼¢ĽBaôF~®²GÌÒEYzk¤°ahlVÕI^CxĈPsBƒºVÀB¶¨R²´D", "@@OR"]
            ],
            "encodeOffsets": [
                [
                    [117381, 22988],
                    [116552, 22934],
                    [116790, 22617],
                    [116973, 22545],
                    [116444, 22536],
                    [116931, 22515],
                    [116496, 22490],
                    [116453, 22449],
                    [113301, 21439],
                    [118726, 21604],
                    [118709, 21486],
                    [113210, 20816],
                    [115482, 22082],
                    [113171, 21585],
                    [113199, 21590],
                    [115232, 22102],
                    [115739, 22373],
                    [115134, 22184],
                    [113056, 21175],
                    [119573, 21271],
                    [119957, 24020],
                    [115859, 22356],
                    [116680, 26053],
                    [116561, 22649]
                ]
            ]
        },
        "properties": {
            "cp": [113.280637, 23.125178],
            "name": "广东",
            "childNum": 24
        }
    }, {
        "id": "450000",
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@H TI¡U", "@@Ɣ_LÊFZgčP­kini«qÇczÍY®¬Ů»qR×ō©DÕ§ƙǃŵTÉĩ±ıdÑnYYĲvNĆĆØÜ Öp}e³¦m©iÓ|¹ħņ|ª¦QF¢Â¬ʖovg¿em^ucäāmÇÖåB¡Õçĝ}FĻ¼Ĺ{µHKsLSđƃrč¤[AgoSŇYMÿ§Ç{FśbkylQxĕ]T·¶[BÑÏGáşşƇeăYSs­FQ}­BwtYğÃ@~CÍQ ×WjË±rÉ¥oÏ ±«ÓÂ¥kwWűue_b­E~µh¯ecl¯Ïr¯EģJğ}w³Ƈē`ãògK_ÛsUʝćğ¶höO¤Ǜn³c`¡yię[ďĵűMę§]XÎ_íÛ]éÛUćİÕBƣ±dy¹T^dûÅÑŦ·PĻþÙ`K¦¢ÍeĥR¿³£[~äu¼dltW¸oRM¢ď\\z}Æzdvň{ÎXF¶°Â_ÒÂÏL©ÖTmu¼ãlīkiqéfA·Êµ\\őDc¥ÝFyÔćcűH_hLÜêĺĐ¨c}rn`½Ì@¸¶ªVLhŒ\\Ţĺk~Ġið°|gtTĭĸ^xvKVGréAébUuMJVÃO¡qĂXËSģãlýà_juYÛÒBG^éÖ¶§EGÅzěƯ¤EkN[kdåucé¬dnYpAyČ{`]þ±X\\ÞÈk¡ĬjàhÂƄ¢Hè ŔâªLĒ^Öm¶ħĊAǦė¸zÚGn£¾rªŀÜt¬@ÖÚSx~øOŒŶÐÂæȠ\\ÈÜObĖw^oÞLf¬°bI lTØBÌF£Ć¹gñĤaYt¿¤VSñK¸¤nM¼JE±½¸ñoÜCƆæĪ^ĚQÖ¦^f´QüÜÊz¯lzUĺš@ìp¶n]sxtx¶@~ÒĂJb©gk{°~c°`Ô¬rV\\la¼¤ôá`¯¹LCÆbxEræOv[H­[~|aB£ÖsºdAĐzNÂðsÞÆĤªbab`ho¡³F«èVZs\\\\ÔRzpp®SĪº¨ÖºNĳd`a¦¤F³¢@`¢ĨĀìhYvlĆº¦Ċ~nS|gźv^kGÆÀè·"]
            ],
            "encodeOffsets": [
                [
                    [111707, 21520],
                    [113706, 26955]
                ]
            ]
        },
        "properties": {
            "cp": [108.320004, 22.82402],
            "name": "广西",
            "childNum": 2
        }
    }, {
        "id": "460000",
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@¦Ŝil¢XƦƞòïè§ŞCêɕrŧůÇąĻõ·ĉ³œ̅kÇm@ċȧŧĥĽʉ­ƅſȓÒË¦ŝE}ºƑ[ÍĜȋ gÎfǐÏĤ¨êƺ\\Ɔ¸ĠĎvʄȀÐ¾jNðĀÒRZǆzÐĊ¢DÀɘZ"],
            "encodeOffsets": [
                [112750, 20508]
            ]
        },
        "properties": {
            "cp": [110.33119, 20.031971],
            "name": "海南",
            "childNum": 1
        }
    }, {
        "id": "510000",
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@LqSn", "@@ĆOìÛÐ@ĞǔNY{¤Á§di´ezÝúØãwIþËQÇ¦ÃqÉSJ»ĂéʔõÔƁİlƞ¹§ĬqtÀƄmÀêErĒtD®ċæcQE®³^ĭ¥©l}äQtoŖÜqÆkµªÔĻĴ¡@Ċ°B²Èw^^RsºTĀ£ŚæQPJvÄz^Đ¹Æ¯fLà´GC²dt­ĀRt¼¤ĦOðğfÔðDŨŁĞƘïPÈ®âbMüÀXZ ¸£@Å»»QÉ­]dsÖ×_Í_ÌêŮPrĔĐÕGĂeZÜîĘqBhtO ¤tE[h|YÔZśÎs´xº±Uñt|OĩĠºNbgþJy^dÂY Į]Řz¦gC³R`Āz¢Aj¸CL¤RÆ»@­Ŏk\\Ç´£YW}z@Z}Ã¶oû¶]´^NÒ}èNªPÍy¹`S°´ATeVamdUĐwʄvĮÕ\\uÆŗ¨Yp¹àZÂmWh{á}WØǍÉüwga§ßAYrÅÂQĀÕ¬LŐý®Xøxª½Ű¦¦[þ`ÜUÖ´òrÙŠ°²ÄkĳnDX{U~ET{ļº¦PZcjF²Ė@pg¨B{u¨ŦyhoÚD®¯¢ WòàFÎ¤¨GDäz¦kŮPġqË¥À]eâÚ´ªKxīPÖ|æ[xÃ¤JÞĥsNÖ½I¬nĨY´®ÐƐmDŝuäđđEbee_v¡}ìęǊē}qÉåT¯µRs¡M@}ůaa­¯wvƉåZw\\Z{åû`[±oiJDÅ¦]ĕãïrG réÏ·~ąSfy×Í·ºſƽĵȁŗūmHQ¡Y¡®ÁÃ×t«­T¤JJJyJÈ`Ohß¦¡uËhIyCjmÿwZGTiSsOB²fNmsPa{M{õE^Hj}gYpaeu¯oáwHjÁ½M¡pMuåmni{fk\\oÎqCwEZ¼KĝAy{m÷LwO×SimRI¯rKõBS«sFe]fµ¢óY_ÆPRcue°Cbo×bd£ŌIHgtrnyPt¦foaXďxlBowz_{ÊéWiêEGhÜ¸ºuFĈIxf®Y½ĀǙ]¤EyF²ċw¸¿@g¢§RGv»áW`ÃĵJwi]t¥wO­½a[×]`Ãi­üL¦LabbTÀåc}ÍhÆh®BHî|îºÉk­¤Sy£ia©taį·Ɖ`ō¥UhOĝLk}©Fos´JmµlŁuønÑJWÎªYÀïAetTŅÓGË«bo{ıwodƟ½OġÜÂµxàNÖ¾P²§HKv¾]|BÆåoZ`¡Ø`ÀmºĠ~ÌÐ§nÇ¿¤]wğ@srğu~Io[é±¹ ¿ſđÓ@qg¹zƱřaí°KtÇ¤V»Ã[ĩǭƑ^ÇÓ@áťsZÏÅĭƋěpwDóÖáŻneQËq·GCœýS]x·ýq³OÕ¶Qzßti{řáÍÇWŝŭñzÇWpç¿JXĩè½cFÂLiVjx}\\NŇĖ¥GeJA¼ÄHfÈu~¸Æ«dE³ÉMA|bÒćhG¬CMõƤąAvüVéŀ_VÌ³ĐwQj´·ZeÈÁ¨X´Æ¡Qu·»ÕZ³ġqDoy`L¬gdp°şp¦ėìÅĮZ°Iähzĵf²å ĚÑKpIN|Ñz]ń·FU×é»R³MÉ»GM«kiér}Ã`¹ăÞmÈnÁîRǀ³ĜoİzŔwǶVÚ£À]ɜ»ĆlƂ²ĠþTº·àUȞÏʦ¶I«dĽĢdĬ¿»Ĕ×h\\c¬ä²GêëĤł¥ÀǿżÃÆMº}BÕĢyFVvwxBèĻĒ©Ĉt@Ğû¸£B¯¨ˋäßkķ½ªôNÔ~t¼Ŵu^s¼{TA¼ø°¢İªDè¾Ň¶ÝJ®Z´ğ~Sn|ªWÚ©òzPOȸbð¢|øĞA"]
            ],
            "encodeOffsets": [
                [
                    [108815, 30935],
                    [100197, 35028]
                ]
            ]
        },
        "properties": {
            "cp": [104.065735, 30.659462],
            "name": "四川",
            "childNum": 2
        }
    }, {
        "id": "520000",
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@G\\lY£cj", "@@q|mc¯vÏV", "@@hÑ£IsNgßHHªķÃh_¹¡ĝÄ§ń¦uÙùgS¯JH|sÝÅtÁïyMDč»eÕtA¤{b\\}G®u\\åPFqwÅaDK°ºâ_£ùbµmÁÛĹM[q|hlaªāI}Ñµ@swtwm^oµDéĽŠyVky°ÉûÛR³e¥]RÕěħ[ƅåÛDpJiVÂF²I»mN·£LbÒYbWsÀbpkiTZĄă¶Hq`ĥ_J¯ae«KpÝx]aĕÛPÇȟ[ÁåŵÏő÷Pw}TÙ@Õs«ĿÛq©½m¤ÙH·yǥĘĉBµĨÕnđ]K©œáGçş§ÕßgǗĦTèƤƺ{¶ÉHÎd¾ŚÊ·OÐjXWrãLyzÉAL¾ę¢bĶėy_qMĔąro¼hĊw¶øV¤w²Ĉ]ÊKx|`ź¦ÂÈdrcÈbe¸`I¼čTF´¼Óýȃr¹ÍJ©k_șl³´_pĐ`oÒh¶pa^ÓĔ}D»^Xy`d[KvJPhèhCrĂĚÂ^Êƌ wZL­Ġ£ÁbrzOIlMMĪŐžËr×ÎeŦtw|¢mKjSǘňĂStÎŦEtqFT¾Eì¬¬ôxÌO¢ K³ŀºäYPVgŎ¦ŊmŞ¼VZwVlz¤£Tl®ctĽÚó{G­AÇge~Îd¿æaSba¥KKûj®_Ä^\\Ø¾bP®¦x^sxjĶI_Ä Xâ¼Hu¨Qh¡À@Ëô}±GNìĎlT¸`V~R°tbÕĊ`¸úÛtÏFDu[MfqGH·¥yAztMFe|R_GkChZeÚ°tov`xbDnÐ{E}ZèxNEÞREn[Pv@{~rĆAB§EO¿|UZ~ìUf¨J²ĂÝÆsªB`s¶fvö¦Õ~dÔq¨¸º»uù[[§´sb¤¢zþF¢ÆÀhÂW\\ıËIÝo±ĭŠ£þÊs}¡R]ěDg´VG¢j±®èºÃmpU[Áëº°rÜbNu¸}º¼`niºÔXĄ¤¼ÔdaµÁ_ÃftQQgR·Ǔv}Ý×ĵ]µWc¤F²OĩųãW½¯K©]{LóµCIµ±Mß¿h©āq¬o½~@i~TUxð´Đhw­ÀEîôuĶb[§nWuMÆJl½]vuıµb"]
            ],
            "encodeOffsets": [
                [
                    [112158, 27383],
                    [112105, 27474],
                    [112095, 27476]
                ]
            ]
        },
        "properties": {
            "cp": [106.713478, 26.578343],
            "name": "贵州",
            "childNum": 3
        }
    }, {
        "id": "530000",
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@[ùx½}ÑRHYīĺûsÍniEoã½Ya²ė{c¬ĝgĂsAØÅwďõzFjw}«Dx¿}Uũlê@HÅ­F¨ÇoJ´Ónũuą¡Ã¢pÒÅØ TF²xa²ËXcÊlHîAßËŁkŻƑŷÉ©hW­æßUËs¡¦}teèÆ¶StÇÇ}Fd£jĈZĆÆ¤Tč\\D}O÷£U§~ŃGåŃDĝ¸Tsd¶¶Bª¤u¢ŌĎo~t¾ÍŶÒtD¦ÚiôözØX²ghįh½Û±¯ÿm·zR¦Ɵ`ªŊÃh¢rOÔ´£Ym¼èêf¯ŪĽncÚbw\\zlvWªâ ¦gmĿBĹ£¢ƹřbĥkǫßeeZkÙIKueT»sVesbaĕ  ¶®dNĄÄpªy¼³BE®lGŭCǶwêżĔÂepÍÀQƞpC¼ŲÈ­AÎô¶RäQ^Øu¬°_Èôc´¹ò¨PÎ¢hlĎ¦´ĦÆ´sâÇŲPnÊD^¯°Upv}®BPÌªjǬxSöwlfòªvqĸ|`H­viļndĜ­Ćhňem·FyÞqóSį¯³X_ĞçêtryvL¤§z¦c¦¥jnŞklD¤øz½ĜàĂŧMÅ|áƆàÊcðÂFÜáŢ¥\\\\ºİøÒÐJĴîD¦zK²ǏÎEh~CD­hMn^ÌöÄ©ČZÀaüfɭyœpį´ěFűk]Ôě¢qlÅĆÙa¶~ÄqêljN¬¼HÊNQ´ê¼VØ¸E^ŃÒyM{JLoÒęæe±Ķygã¯JYÆĭĘëo¥Šo¯hcK«z_prC´ĢÖY¼ v¸¢RÅW³Â§fÇ¸Yi³xR´ďUË`êĿUûuĆBƣöNDH«ĈgÑaB{ÊNF´¬c·Åv}eÇÃGB»If¦HňĕM~[iwjUÁKE¾dĪçWIèÀoÈXòyŞŮÈXâÎŚj|àsRyµÖPr´þ ¸^wþTDŔHr¸RÌmfżÕâCôoxĜƌÆĮÐYtâŦÔ@]ÈǮƒ\\Ī¼Ä£UsÈ¯LbîƲŚºyhr@ĒÔƀÀ²º\\êpJ}ĠvqtĠ@^xÀ£È¨mËÏğ}n¹_¿¢×Y_æpÅA^{½Lu¨GO±Õ½ßM¶wÁĢÛPƢ¼pcĲx|apÌ¬HÐŊSfsðBZ¿©XÏÒKk÷Eû¿SrEFsÕūkóVǥŉiTL¡n{uxţÏhôŝ¬ğōNNJkyPaqÂğ¤K®YxÉƋÁ]āęDqçgOgILu\\_gz]W¼~CÔē]bµogpÑ_oď`´³Țkl`IªºÎȄqÔþ»E³ĎSJ»_f·adÇqÇc¥Á_Źw{L^É±ćxU£µ÷xgĉp»ĆqNē`rĘzaĵĚ¡K½ÊBzyäKXqiWPÏÉ¸½řÍcÊG|µƕƣGË÷k°_^ý|_zċBZocmø¯hhcæ\\lMFlư£ĜÆyHF¨µêÕ]HAàÓ^it `þßäkĤÎT~Wlÿ¨ÔPzUCNVv [jâôDôď[}z¿msSh¯{jïğl}šĹ[őgK©U·µË@¾m_~q¡f¹ÅË^»f³ø}Q¡ÖË³gÍ±^Ç\\ëÃA_¿bWÏ[¶ƛé£F{īZgm@|kHǭƁć¦UĔť×ëǟeċ¼ȡȘÏíBÉ£āĘPªĳ¶ŉÿy©nď£G¹¡I±LÉĺÑdĉÜW¥}gÁ{aqÃ¥aıęÏZÁ`"],
            "encodeOffsets": [
                [104636, 22969]
            ]
        },
        "properties": {
            "cp": [102.712251, 25.040609],
            "name": "云南",
            "childNum": 1
        }
    }, {
        "id": "540000",
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@ÂhľxŖxÒVºÅâAĪÝȆµę¯Ňa±r_w~uSÕňqOj]ɄQ£ZUDûoY»©M[L¼qãË{VÍçWVi]ë©Ä÷àyƛhÚU°adcQ~Mx¥caÛcSyFÖk­uRýq¿ÔµQĽ³aG{¿FµëªéĜÿª@¬·K·àariĕĀ«V»ŶĴūgèLǴŇƶaftèBŚ£^âǐÝ®M¦ÁǞÿ¬LhJ¾óƾÆºcxwf]Y´¦|QLn°adĊ\\¨oǀÍŎ´ĩĀd`tÊQŞŕ|¨C^©Ĉ¦¦ÎJĊ{ëĎjª²rÐl`¼Ą[t|¦Stè¾PÜK¸dƄı]s¤î_v¹ÎVòŦj£Əsc¬_Ğ´|Ł¦Av¦w`ăaÝaa­¢e¤ı²©ªSªÈMĄwÉØŔì@T¤Ę\\õª@þo´­xA sÂtŎKzó²ÇČµ¢r^nĊ­Æ¬×üG¢³ {âĊ]G~bÀgVjzlhǶfOfdªB]pjTOtĊn¤}®¦Č¥d¢¼»ddY¼t¢eȤJ¤}Ǿ¡°§¤AÐlc@ĝsªćļđAçwxUuzEÖġ~AN¹ÄÅȀŻ¦¿ģŁéì±Hãd«g[Ø¼ēÀcīľġ¬cJµÐʥVȝ¸ßS¹ý±ğkƁ¼ą^ɛ¤Ûÿb[}¬ōõÃ]ËNm®g@Bg}ÍF±ǐyL¥íCIĳÏ÷Ñį[¹¦[âšEÛïÁÉdƅß{âNÆāŨß¾ě÷yC£k­´ÓH@Â¹TZ¥¢į·ÌAÐ§®Zcv½Z­¹|ÅWZqgW|ieZÅYVÓqdqbc²R@c¥Rã»GeeƃīQ}J[ÒK¬Ə|oėjġĠÑN¡ð¯EBčnwôɍėª²CλŹġǝʅįĭạ̃ūȹ]ΓͧgšsgȽóϧµǛęgſ¶ҍć`ĘąŌJÞä¤rÅň¥ÖÁUětęuůÞiĊÄÀ\\Æs¦ÓRb|Â^řÌkÄŷ¶½÷f±iMÝ@ĥ°G¬ÃM¥n£Øąğ¯ß§aëbéüÑOčk£{\\eµª×MÉfm«Ƒ{Å×Gŏǩãy³©WÑăû··Qòı}¯ãIéÕÂZ¨īès¶ZÈsæĔTŘvgÌsN@îá¾ó@ÙwU±ÉTå»£TđWxq¹Zobs[×¯cĩvėŧ³BM|¹kªħ¥TzNYnÝßpęrñĠĉRS~½ěVVµõ«M££µBĉ¥áºae~³AuĐh`Ü³ç@BÛïĿa©|z²Ý¼D£àč²ŸIûI āóK¥}rÝ_Á´éMaň¨~ªSĈ½½KÙóĿeƃÆB·¬ën×W|Uº}LJrƳlŒµ`bÔ`QÐÓ@s¬ñIÍ@ûws¡åQÑßÁ`ŋĴ{ĪTÚÅTSÄ³Yo|Ç[Ç¾µMW¢ĭiÕØ¿@MhpÕ]jéò¿OƇĆƇpêĉâlØwěsǩĵ¸cbU¹ř¨WavquSMzeo_^gsÏ·¥Ó@~¯¿RiīB\\qTGªÇĜçPoÿfñòą¦óQīÈáPābß{ZŗĸIæÅhnszÁCËìñÏ·ąĚÝUm®ó­L·ăUÈíoù´Êj°ŁŤ_uµ^°ìÇ@tĶĒ¡ÆM³Ģ«İĨÅ®ğRāðggheÆ¢zÊ©Ô\\°ÝĎz~ź¤PnMĪÖB£kné§żćĆKĒ°¼L¶èâz¨u¦¥LDĘz¬ýÎmĘd¾ßFzhg²Fy¦ĝ¤ċņbÎ@yĄæm°NĮZRÖíJ²öLĸÒ¨Y®ƌÐVàtt_ÚÂyĠz]ŢhzĎ{ÂĢXc|ÐqfO¢¤ögÌHNPKŖUú´xx[xvĐCûĀìÖT¬¸^}Ìsòd´_KgžLĴÀBon|H@Êx¦BpŰŌ¿fµƌA¾zǈRx¶FkĄźRzŀ~¶[´HnªVƞuĒ­È¨ƎcƽÌm¸ÁÈM¦x͊ëÀxǆBú^´W£dkɾĬpw˂ØɦļĬIŚÊnŔa¸~J°îlɌxĤÊÈðhÌ®gT´øàCÀ^ªerrƘd¢İP|Ė ŸWªĦ^¶´ÂLaT±üWƜǀRÂŶUńĖ[QhlLüAÜ\\qRĄ©"],
            "encodeOffsets": [
                [90849, 37210]
            ]
        },
        "properties": {
            "cp": [91.132212, 29.660361],
            "name": "西藏",
            "childNum": 1
        }
    }, {
        "id": "610000",
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@¸ÂW¢xR­Fq§uF@N¢XLRMº[ğȣſï|¥Jkc`sŉǷ£Y³WN«ùMëï³ÛIg÷±mTșÚÒķø©þ¥yÓğęmWµÎumZyOŅƟĥÓ~sÑL¤µaÅY¦ocyZ{y c]{Ta©`U_Ěē£ωÊƍKùK¶ȱÝƷ§{û»ÅÁȹÍéuĳ|¹cÑdìUYOuFÕÈYvÁCqÓTǢí§·S¹NgV¬ë÷Át°DØ¯C´ŉƒópģ}ąiEËFéGU¥×K§­¶³BČ}C¿åċ`wġB·¤őcƭ²ő[Å^axwQOñJÙïŚĤNĔwƇÄńwĪ­o[_KÓª³ÙnKÇěÿ]ďă_d©·©Ýŏ°Ù®g]±ß×¥¬÷m\\iaǑkěX{¢|ZKlçhLtŇîŵœè[É@ƉĄEtƇÏ³­ħZ«mJ×¾MtÝĦ£IwÄå\\Õ{OwĬ©LÙ³ÙTª¿^¦rÌĢŭO¥lãyC§HÍ£ßEñX¡­°ÙCgpťzb`wIvA|¥hoĕ@E±iYd¥OÿµÇvPW|mCĴŜǂÒW¶¸AĜh^Wx{@¬­F¸¡ķn£P|ªĴ@^ĠĈæbÔc¶lYi^MicĎ°Â[ävï¶gv@ÀĬ·lJ¸sn|¼u~a]ÆÈtŌºJpþ£KKf~¦UbyäIĺãnÔ¿^­ŵMThĠÜ¤ko¼Ŏìąǜh`[tRd²Ĳ_XPrɲlXiL§à¹H°Ȧqº®QCbAŌJ¸ĕÚ³ĺ§ `d¨YjiZvRĺ±öVKkjGȊÄePĞZmļKÀ[`ösìhïÎoĬdtKÞ{¬èÒÒBÔpĲÇĬJŊ¦±J«[©ārHµàåVKe§|P²ÇÓ·vUzgnN¾yI@oHĆÛķhxen¡QQ±ƝJǖRbzy¸ËÐl¼EºpĤ¼x¼½~Ğà@ÚüdK^mÌSjp²ȮµûGĦ}Ħðǚ¶òƄjɂz°{ºØkÈęâ¦jªBg\\ċ°s¬]jú EȌǆ¬stRÆdĠİwÜ¸ôW¾ƮłÒ_{Ìû¼jº¹¢GǪÒ¯ĘZ`ºŊecņą~BÂgzpâēòYƲȐĎ"],
            "encodeOffsets": [
                [113634, 40474]
            ]
        },
        "properties": {
            "cp": [108.948024, 34.263161],
            "name": "陕西",
            "childNum": 1
        }
    }, {
        "id": "620000",
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@Vu_^", "@@ųEĠtt~nkh`Q¦ÅÄÜdwAb×ĠąJ¤DüègĺqBqj°lI¡Ĩ¶ĖIHdjÎB°aZ¢KJO[|A£Dx}NĂ¬HUnrk kp¼Y kMJn[aGáÚÏ[½rc}aQxOgsPMnUsncZsKúvAtÞġ£®ĀYKdnFw¢JE°Latf`¼h¬we|Æbj}GA·~W`¢MC¤tL©Ĳ°qdfObÞĬ¹ttu`^ZúE`[@Æsîz®¡CƳƜG²R¢RmfwĸgÜą G@pzJM½mhVy¸uÈÔO±¨{LfæU¶ßGĂq\\ª¬²I¥IŉÈīoıÓÑAçÑ|«LÝcspīðÍgtë_õ\\ĉñLYnĝgRǡÁiHLlõUĹ²uQjYi§Z_c¨´ĹĖÙ·ŋIaBD­R¹ȥr¯GºßK¨jWkɱOqWĳ\\a­Q\\sg_ĆǛōëp»£lğÛgSŶN®À]ÓämĹãJaz¥V}Le¤Lýo¹IsŋÅÇ^bz³tmEÁ´a¹cčecÇNĊãÁ\\č¯dNj]jZµkÓdaćå]ğĳ@ ©O{¤ĸm¢E·®«|@Xwg]Aģ±¯XǁÑǳªcwQÚŝñsÕ³ÛV_ý¥\\ů¥©¾÷w©WÕÊĩhÿÖÁRo¸V¬âDb¨hûxÊ×ǌ~Zâg|XÁnßYoº§ZÅŘv[ĭÖʃuďxcVbnUSfB¯³_TzºÎO©çMÑ~M³]µ^püµÄY~y@X~¤Z³[Èōl@®Å¼£QK·Di¡ByÿQ_´D¥hŗy^ĭÁZ]cIzýah¹MĪğPs{ò²Vw¹t³ŜË[Ñ}X\\gsF£sPAgěp×ëfYHāďÖqēŭOÏëdLü\\it^c®RÊº¶¢H°mrY£B¹čIoľu¶uI]vģSQ{UŻÅ}QÂ|Ì°ƅ¤ĩŪU ęĄÌZÒ\\v²PĔ»ƢNHĂyAmƂwVm`]ÈbH`Ì¢²ILvĜH®¤Dlt_¢JJÄämèÔDëþgºƫaʎÌrêYi~ Îİ¤NpÀA¾Ĕ¼bð÷®üszMzÖĖQdȨýv§Tè|ªHÃ¾a¸|Ð ƒwKĢx¦ivr^ÿ ¸l öæfƟĴ·PJv}n\\h¹¶v·À|\\ƁĚN´ĜçèÁz]ġ¤²¨QÒŨTIlªťØ}¼˗ƦvÄùØEÂ«FïËIqōTvāÜŏíÛßÛVj³âwGăÂíNOPìyV³ŉĖýZso§HÑiYw[ß\\X¦¥c]ÔƩÜ·«jÐqvÁ¦m^ċ±R¦΋ƈťĚgÀ»IïĨʗƮ°ƝĻþÍAƉſ±tÍEÕÞāNUÍ¡\\ſčåÒʻĘm ƭÌŹöʥëQ¤µ­ÇcƕªoIýIÉ_mkl³ăƓ¦j¡YzŇi}Msßõīʋ }ÁVm_[n}eı­Uĥ¼ªI{Î§DÓƻėojqYhĹT©oūĶ£]ďxĩǑMĝq`B´ƃ˺Чç~²ņj@¥@đ´ί}ĥtPńÇ¾V¬ufÓÉCtÓ̻¹£G³]ƖƾŎĪŪĘ̖¨ʈĢƂlɘ۪üºňUðǜȢƢż̌ȦǼĤŊɲĖÂ­KqĘŉ¼ĔǲņɾªǀÞĈĂD½ĄĎÌŗĞrôñnN¼â¾ʄľԆ|Ǆ֦ज़ȗǉ̘̭ɺƅêgV̍ʆĠ·ÌĊv|ýĖÕWĊǎÞ´õ¼cÒÒBĢ͢UĜð͒s¨ňƃLĉÕÝ@ɛƯ÷¿Ľ­ĹeȏĳëCȚDŲyê×Ŗyò¯ļcÂßYtÁƤyAã˾J@ǝrý@¤rz¸oP¹ɐÚyáHĀ[JwcVeȴÏ»ÈĖ}ƒŰŐèȭǢόĀƪÈŶë;Ñ̆ȤМľĮEŔĹŊũ~ËUă{ĻƹɁύȩþĽvĽƓÉ@ēĽɲßǐƫʾǗĒpäWÐxnsÀ^ƆwW©¦cÅ¡Ji§vúF¶¨c~c¼īeXǚ\\đ¾JwÀďksãAfÕ¦L}waoZD½Ml«]eÒÅaÉ²áo½FõÛ]ĻÒ¡wYR£¢rvÓ®y®LFLzĈôe]gx}|KK}xklL]c¦£fRtív¦PŨ£", "@@M T¥"]
            ],
            "encodeOffsets": [
                [
                    [108619, 36299],
                    [108594, 36341],
                    [108600, 36306]
                ]
            ]
        },
        "properties": {
            "cp": [103.823557, 36.058039],
            "name": "甘肃",
            "childNum": 3
        }
    }, {
        "id": "630000",
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@InJo", "@@CÆ½OŃĦsΰ~Ē³¦@@Ņi±è}ШƄ˹A³r_ĞǒNĪĐw¤^ŬĵªpĺSZgrpiƼĘÔ¨C|ÍJ©Ħ»®VĲ~f\\m `UnÂ~ʌĬàöNt~ňjy¢ZiƔ¥Ąk´nl`JÊJþ©pdƖ®È£¶ìRʦźõƮËnʼėæÑƀĎ[¢VÎĂMÖÝÎF²sƊƀÎBļýƞ¯ʘƭðħ¼Jh¿ŦęΌƇ¥²Q]Č¥nuÂÏri¸¬ƪÛ^Ó¦d¥[Wàx\\ZjÒ¨GtpþYŊĕ´zUOëPîMĄÁxH´áiÜUàîÜŐĂÛSuŎrJðÌ¬EFÁú×uÃÎkrĒ{V}İ«O_ÌËĬ©ÓŧSRÑ±§Ģ£^ÂyèçěM³Ƃę{[¸¿uºµ[gt£¸OƤĿéYõ·kĀq]juw¥DĩƍõÇPéÄ½G©ã¤GuȧþRcÕĕNyyût­øï»a½ē¿BMoį£Íj}éZËqbʍƬh¹ìÿÓAçãnIÃ¡I`ks£CG­ěUy×Cy@¶ʡÊBnāzGơMē¼±O÷õJËĚăVĪũƆ£¯{ËL½ÌzżVR|ĠTbuvJvµhĻĖHAëáa­OÇðñęNwœľ·LmI±íĠĩPÉ×®ÿscB³±JKßĊ«`ađ»·QAmOVţéÿ¤¹SQt]]Çx±¯A@ĉĳ¢Óļ©l¶ÅÛrŕspãRk~¦ª]Į­´FRåd­ČsCqđéFn¿ÅƃmÉx{W©ºƝºįkÕƂƑ¸wWūÐ©ÈF£\\tÈ¥ÄRÈýÌJ lGr^×äùyÞ³fjc¨£ÂZ|ǓMĝÏ@ëÜőRĝ÷¡{aïȷPu°ËXÙ{©TmĠ}Y³­ÞIňµç½©C¡į÷¯B»|St»]vųs»}MÓ ÿʪƟǭA¡fs»PY¼c¡»¦cċ­¥£~msĉPSi^o©AecPeǵkgyUi¿h}aHĉ^|á´¡HØûÅ«ĉ®]m¡qċ¶±ÈyôōLÁstB®wn±ă¥HSòė£Së@×œÊăxÇN©©T±ª£Ĳ¡fb®Þbb_Ą¥xu¥B{łĝ³«`dƐt¤ťiñÍUuºí`£^tƃĲc·ÛLO½sç¥Ts{ă\\_»kÏ±q©čiìĉ|ÍI¥ć¥]ª§D{ŝŖÉR_sÿc³ĪōƿÎ§p[ĉc¯bKmR¥{³Ze^wx¹dƽÅ½ôIg §Mĕ ƹĴ¿ǣÜÍ]Ý]snåA{eƭ`ǻŊĿ\\ĳŬűYÂÿ¬jĖqßb¸L«¸©@ěĀ©ê¶ìÀEH|´bRľÓ¶rÀQþvl®ÕETzÜdb hw¤{LRdcb¯ÙVgƜßzÃôì®^jUèXÎ|UäÌ»rK\\ªN¼pZCüVY¤ɃRi^rPŇTÖ}|br°qňbĚ°ªiƶGQ¾²x¦PmlŜ[Ĥ¡ΞsĦÔÏâ\\ªÚŒU\\f¢N²§x|¤§xĔsZPòʛ²SÐqF`ªVÞŜĶƨVZÌL`¢dŐIqr\\oäõFÎ·¤»Ŷ×h¹]ClÙ\\¦ďÌį¬řtTӺƙgQÇÓHţĒ´ÃbEÄlbʔC|CŮkƮ[ʼ¬ň´KŮÈΰÌĪ¶ƶlðļATUvdTGº̼ÔsÊDÔveMg"]
            ],
            "encodeOffsets": [
                [
                    [105308, 37219],
                    [95370, 40081]
                ]
            ]
        },
        "properties": {
            "cp": [101.778916, 36.623178],
            "name": "青海",
            "childNum": 2
        }
    }, {
        "id": "640000",
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@KëÀęĞ«Oęȿȕı]ŉ¡åįÕÔ«ǴõƪĚQÐZhv K°öqÀÑS[ÃÖHƖčËnL]ûcÙß@ĝ¾}w»»oģF¹»kÌÏ·{zP§B­¢íyÅt@@á]Yv_ssģ¼ißĻL¾ġsKD£¡N_X¸}B~HaiÅf{«x»ge_bsKF¯¡IxmELcÿZ¤­ĢÝsuBLùtYdmVtNmtOPhRw~bd¾qÐ\\âÙH\\bImlNZ»loqlVmGā§~QCw¤{A\\PKNY¯bFkC¥sks_Ã\\ă«¢ħkJi¯rrAhĹûç£CUĕĊ_ÔBixÅÙĄnªÑaM~ħpOu¥sîeQ¥¤^dkKwlL~{L~hw^ófćKyE­K­zuÔ¡qQ¤xZÑ¢^ļöÜ¾Ep±âbÊÑÆ^fk¬NC¾YpxbK~¥eÖäBlt¿Đx½I[ĒǙWf»Ĭ}d§dµùEuj¨IÆ¢¥dXªƅx¿]mtÏwßRĶX¢͎vÆzƂZò®ǢÌʆCrâºMÞzÆMÒÊÓŊZÄ¾r°Î®Ȉmª²ĈUªĚîøºĮ¦ÌĘk^FłĬhĚiĀĖ¾iİbjË"],
            "encodeOffsets": [
                [109366, 40242]
            ]
        },
        "properties": {
            "cp": [106.278179, 38.46637],
            "name": "宁夏",
            "childNum": 1
        }
    }, {
        "id": "650000",
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@QØĔ²X¨~ǘBºjʐßØvKƔX¨vĊOÃ·¢i@~cĝe_«E}QxgɪëÏÃ@sÅyXoŖ{ô«ŸuXêÎf`C¹ÂÿÐGĮÕĞXŪōŸMźÈƺQèĽôe|¿ƸJR¤ĘEjcUóº¯Ĩ_ŘÁMª÷Ð¥OéÈ¿ÖğǤǷÂFÒzÉx[]­Ĥĝœ¦EP}ûƥé¿İƷTėƫœŕƅƱB»Đ±ēO¦E}`cȺrĦáŖuÒª«ĲπdƺÏØZƴwʄ¤ĖGĐǂZĶèH¶}ÚZצʥĪï|ÇĦMŔ»İĝǈì¥Βba­¯¥ǕǚkĆŵĦɑĺƯxūД̵nơʃĽá½M»òmqóŘĝčË¾ăCćāƿÝɽ©ǱŅ»ēėŊLrÁ®ɱĕģŉǻ̋ȥơŻǛȡVï¹Ň۩ûkɗġƁ§ʇė̕ĩũƽō^ƕUv£ƁQïƵkŏ½ΉÃŭÇ³LŇʻ«ƭ\\lŭD{ʓDkaFÃÄa³ŤđÔGRÈƚhSӹŚsİ«ĐË[¥ÚDkº^Øg¼ŵ¸£EÍöůŉT¡c_ËKYƧUśĵÝU_©rETÏʜ±OñtYwē¨{£¨uM³x½şL©Ùá[ÓÐĥ Νtģ¢\\śnkOw¥±T»ƷFɯàĩÞáB¹ÆÑUwŕĽw]kE½Èå~Æ÷QyěCFmĭZīŵVÁƿQƛûXS²b½KÏ½ĉS©ŷXĕ{ĕK·¥Ɨcqq©f¿]ßDõU³h­gËÇïģÉɋwk¯í}I·œbmÉřīJɥĻˁ×xoɹīlc¤³Xù]ǅA¿w͉ì¥wÇN·ÂËnƾƍdÇ§đ®ƝvUm©³G\\}µĿQyŹlăµEwǇQ½yƋBe¶ŋÀůo¥AÉw@{Gpm¿AĳŽKLh³`ñcËtW±»ÕSëüÿďDu\\wwwù³VLŕOMËGh£õP¡erÏd{ġWÁč|yšg^ğyÁzÙs`s|ÉåªÇ}m¢Ń¨`x¥ù^}Ì¥H«YªƅAÐ¹n~ź¯f¤áÀzgÇDIÔ´AňĀÒ¶ûEYospõD[{ù°]uJqU|Soċxţ[õÔĥkŋÞŭZËºóYËüċrw ÞkrťË¿XGÉbřaDü·Ē÷AÃª[ÄäIÂ®BÕĐÞ_¢āĠpÛÄȉĖġDKwbmÄNôfƫVÉviǳHQµâFù­Âœ³¦{YGd¢ĚÜO {Ö¦ÞÍÀP^bƾl[vt×ĈÍEË¨¡Đ~´î¸ùÎhuè`¸HÕŔVºwĠââWò@{ÙNÝ´ə²ȕn{¿¥{l÷eé^eďXj©î\\ªÑòÜìc\\üqÕ[Č¡xoÂċªbØ­ø|¶ȴZdÆÂońéG\\¼C°ÌÆn´nxÊOĨŪƴĸ¢¸òTxÊǪMīĞÖŲÃɎOvʦƢ~FRěò¿ġ~åŊúN¸qĘ[Ĕ¶ÂćnÒPĒÜvúĀÊbÖ{Äî¸~Ŕünp¤ÂH¾ĄYÒ©ÊfºmÔĘcDoĬMŬS¤s²ʘÚžȂVŦ èW°ªB|ĲXŔþÈJĦÆæFĚêYĂªĂ]øªŖNÞüAfɨJ¯ÎrDDĤ`mz\\§~D¬{vJÂ«lµĂb¤pŌŰNĄ¨ĊXW|ų ¿¾ɄĦƐMTòP÷fØĶK¢ȝ˔Sô¹òEð­`Ɩ½ǒÂň×äı§ĤƝ§C~¡hlåǺŦŞkâ~}FøàĲaĞfƠ¥Ŕd®U¸źXv¢aƆúŪtŠųƠjdƺƺÅìnrh\\ĺ¯äɝĦ]èpĄ¦´LƞĬ´ƤǬ˼Ēɸ¤rºǼ²¨zÌPðŀbþ¹ļD¢¹\\ĜÑŚ¶ZƄ³âjĦoâȴLÊȮĐ­ĚăÀêZǚŐ¤qȂ\\L¢ŌİfÆs|zºeªÙæ§΢{Ā´ƐÚ¬¨Ĵà²łhʺKÞºÖTiƢ¾ªì°`öøu®Ê¾ãÖ"],
            "encodeOffsets": [
                [88824, 50096]
            ]
        },
        "properties": {
            "cp": [87.617733, 43.792818],
            "name": "新疆",
            "childNum": 1
        }
    }, {
        "id": "110000",
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@RºaYÕQaúÍÔiþĩȨWĢü|Ėu[qb[swP@ÅğP¿{\\¯Y²·Ñ¨j¯X\\¯MSvU¯YIŕY{[fk­VÁûtŷmiÍt_H»Ĩ±d`¹­{bwYr³S]§§o¹qGtm_SŧoaFLgQN_dV@Zom_ć\\ßW´ÕiœRcfio§ËgToÛJíĔóu|wP¤XnO¢ÉŦ¯pNÄā¤zâŖÈRpŢZÚ{GrFt¦Òx§ø¹RóäV¤XdżâºWbwŚ¨Ud®bêņ¾jnŎGŃŶnzÚScîĚZen¬"],
            "encodeOffsets": [
                [119421, 42013]
            ]
        },
        "properties": {
            "cp": [116.405285, 39.904989],
            "name": "北京",
            "childNum": 1
        }
    }, {
        "id": "120000",
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@ŬgX§Ü«E¶FÌ¬O_ïlÁgz±AXeµÄĵ{¶]gitgIj·¥ì_iU¨ÐƎk}ĕ{gBqGf{¿aU^fIư³õ{YıëNĿk©ïËZukāAīlĕĥs¡bġ«@dekąI[nlPqCnp{ō³°`{PNdƗqSÄĻNNâyj]äÒD ĬH°Æ]~¡HO¾X}ÐxgpgWrDGpù^LrzWxZ^¨´T\\|~@IzbĤjeĊªz£®ĔvěLmV¾Ô_ÈNW~zbĬvG²ZmDM~~"],
            "encodeOffsets": [
                [120237, 41215]
            ]
        },
        "properties": {
            "cp": [117.190182, 39.125596],
            "name": "天津",
            "childNum": 1
        }
    }, {
        "id": "310000",
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@ɧư¬EpƸÁx]", "@@©²", "@@MA", "@@QpªKWT§¨", "@@bŝÕÕEȣÚƥêImɇǦèÜĠÚÄÓŴ·ʌÇ", "@@Sô¤r]ìƬįǜûȬɋŭ×^sYɍDŋŽąñCG²«ªč@h_p¯A{oloY¬j@Ĳ`gQÚpptǀ^MĲvtbe´Rh@oj¨", "@@ÆLH{a}Eo¦"]
            ],
            "encodeOffsets": [
                [
                    [124702, 32062],
                    [124547, 32200],
                    [124808, 31991],
                    [124726, 32110],
                    [124903, 32376],
                    [124065, 32166],
                    [124870, 31965]
                ]
            ]
        },
        "properties": {
            "cp": [121.472644, 31.231706],
            "name": "上海",
            "childNum": 7
        }
    }, {
        "id": "500000",
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@TÂÛ`Ùƅően½SêqDu[RåÍ¹÷eXÍy¸_ĺę}÷`M¯ċfCVµqŉ÷Zgg^d½pDOÎCn^uf²ènh¼WtƏxRGg¦pVFI±G^Ic´ecGĹÞ½sëÆNäÌ¤KÓe¯|R¸§LÜkPoïƭNï¶}Gywdiù©nkĈzj@Óc£»Wă¹Óf§c[µo·Ó|MvÛaq½«è\\ÂoVnÓØÍ²«bq¿ehCĜ^Q~ Évýş¤²ĮpEĶyhsŊwH½¿gÅ¡ýE¡ya£³t\\¨\\vú¹¼©·Ñr_oÒý¥et³]Et©uÖ¥±ă©KVeë]}wVPÀFA¨ąB}qTjgRemfFmQFÝMyùnÑAmÑCawu_p¯sfÛ_gI_pNysB¦zG¸rHeN\\CvEsÐñÚkcDÖĉsaQ¯}_UzÁē}^R Äd^ÍĸZ¾·¶`wećJE¹vÛ·HgéFXjÉê`|ypxkAwWĐpb¥eOsmzwqChóUQl¥F^lafanòsrEvfQdÁUVfÎvÜ^eftET¬ôA\\¢sJnQTjPØxøK|nBzĞ»LYFDxÓvr[ehľvN¢o¾NiÂxGpâ¬zbfZo~hGi]öF||NbtOMn eA±tPTLjpYQ|SHYĀxinzDJÌg¢và¥Pg_ÇzIIII£®S¬ØsÎ¼¥¨^LnGĲļĲƤjÎƀƾ¹¸ØÎezĆT¸}êÐqHðqĖä¥^CÆIj²p\\_ æüY|[YxƊæu°xb®Űb@~¢NQt°¶Sæ Ê~rǉĔëĚ¢~uf`faĔJåĊnÔ]jƎćÊ@£¾a®£Ű{ŶĕFègLk{Y|¡ĜWƔtƬJÑxq±ĢN´òKLÈÃ¼D|s`ŋć]Ã`đMùƱ¿~Y°ħ`ƏíW½eI½{aOIrÏ¡ĕŇapµÜƃġ²"],
            "encodeOffsets": [
                [111728, 31311]
            ]
        },
        "properties": {
            "cp": [106.504962, 29.533155],
            "name": "重庆",
            "childNum": 1
        }
    }, {
        "id": "810000",
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@AlFi", "@@mp", "@@EpHo", "@@rMUwAS¬]", "@@ea¢pl¸Eõ¹hj[]ÔCÎ@lj¡uBX´AI¹[yDU]W`çwZkmcMpÅv}IoJlcafŃK°ä¬XJmÐ đhI®æÔtSHnEÒrÄc"]
            ],
            "encodeOffsets": [
                [
                    [117111, 23002],
                    [117072, 22876],
                    [117045, 22887],
                    [116882, 22747],
                    [116975, 23082]
                ]
            ]
        },
        "properties": {
            "cp": [114.173355, 22.320048],
            "name": "香港",
            "childNum": 5
        }
    }, {
        "id": "820000",
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@áw{Îr"],
            "encodeOffsets": [
                [116285, 22746]
            ]
        },
        "properties": {
            "cp": [113.54909, 22.198951],
            "name": "澳门",
            "childNum": 1
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@øHztÈlrrĒ¸KurOm¤KrdTJtxtTH]Sy¦F|UF­~Ti|EHSE[iW@WxMLNMUPp«vMnctFgx\\t]di^F¥eJUkYIGug[iRQg]§O^a¿goWH[@m}ssãÐěÀcNō~¬y¾ghB"],
            "encodeOffsets": [
                [107294, 10771]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@[MGéØyPZKClQjLNYOu`YE^Udj\\EdXXxb]pZVPrrfZhGrTÀIrSEe{lIBvLh[BbeQHepFlQVaSijkK``iaeNqI]YuMUOXwQugqkc`³OMZwEM{sOãZ¿ZEiNS^CawBuL§BWogI{NZwKcc[wX]dEhuWSdHaviTS_Hpi]BdAo]cTIV]vK]@Qn\\ ~AflL¤]NRC~bH@UZbºgl^TNjnnOPni"],
            "encodeOffsets": [
                [108734, 22123]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@^phnvC`t|Kn^tRhiOOnyogU\\kMU~cPulytMJ¤qf~hGÊX`cjMNbGBsyLT]Gb^hQLY{aVkqDWS_[Zu©§s£Hq[FuX«KUOF[haPcC@UokM{]kDk[KwYAu`CX^CNnEj]`FdSryZ_AcdoPMciEo[qEcgQqVurUhMq|ThSh~XDX}zNrIr`^fO^d`AdfVAtRxzbTvMhN^Y|pEpglDZ"],
            "encodeOffsets": [
                [108065, 23177]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@`bBENdLX`EyvSb@rncAVWlDNUfZFfYK\\RLTUReUćBgP\\|_j@dodLXYj@zpJ\\y~[LbldbUS_\\¿MGTaĳµíei¡Btuz[Q\\mBgboI}bPr_AQjg`tzHjX"],
            "encodeOffsets": [
                [107789, 9625]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@JUS^dBpcAj^oGT`jSbu GTcvXFg^cxWGURP[gmF[mgM]PoIlaSsXk]yPDfbzixmG^avWºLXa\\RXQh`"],
            "encodeOffsets": [
                [108481, 21754]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@`|[d\\heSlp¤ILpEd@tnvP@atJfM¦AJ³I]d_TGxZnhZ\\nvXr|\\[ZF^qfHBuzqZwMYzÁF¥_qKsyßCc}_EkpeJMSWqWyYoYNCdWTCzP`nIh}IjWneCcnPj"],
                ["@@NVhUiUKV"],
                ["@@PiiOO{`{FmtPflfP"]
            ],
            "encodeOffsets": [
                [
                    [109580, 10768]
                ],
                [
                    [109226, 8879]
                ],
                [
                    [109217, 8971]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@ixNDªvî`\\SÔlOut@qb[ªaÂ]¤goIMa^gKoP_Sc¡©]F{iOiCsxeTq^e{¯QÉĄ©¬oj³vxol{Zq®xmxVBkNQN`"],
            "encodeOffsets": [
                [108580, 10546]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@Xj¨vX^ctVDKp®Hnl@lQ^~Mri\\HrQzAe`gl[a@N}l·TOjOaZIk^y ÃKSfa]D_ljeO@c`«FoM_P]Yk`N[PkYciIMtVT_Ø_bS@kaWp_IahE}H`}n]Y¡cS¡EwYDn«KeQk¤KfXK`R`UH\\tCmdOtYPKf¸WvJbqd]hKnYXmHIiJj[b]ªDpo¬JrIHnYnHzMf"],
            "encodeOffsets": [
                [111236, 14894]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@TLÂIydbbwwoC¡RYº^Ho¶QJtClx^@|`\\SF}qqWAHwVexI\\RmC|r^Ab`nGX}[[H[_m@w_ENk_QNerEjs@JmWeJagOisaWuKwb]voINsQSWjk_G]sP_pIqMzHgeQYXFrOdPKªgCWTFjkNG|BuxF iluAmVSacZNV£xBtcgNHiXTtenffFtXhTVh"],
            "encodeOffsets": [
                [108979, 11771]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@jŏJÅAXujSjBUl_`Hizc`yLohOa©_WEygFca§YcaAseLmaFgQ[^pKíiëaQeiI[XameKGakMM]___[L\\\\W~mHa_]B{qDn[QwJUfGxXBrrE~[T_@{w]ksDIµRGp¹]QZD¢xpaxcazÁJSKP X\\fĐFj_`_GxºMnN\\hN­ĎhArb\\_vGrXnYĈL^`zqVlvBhº@x[~JSrXª^ttRbbVJfjRI^pND`xL|T^xLpZ"],
            "encodeOffsets": [
                [109780, 12592]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@l@R}Qc[N[LL"],
                ["@@tlT@OhYjChLhZJ¸JĤQ¬WÌqDw\\qC]Viz\\C`tÈ^V`lRV`v\\ª¬WxgAaj^AbfENipDbZYJpVotTRhbh¾K`hSRLAG±zq¸UZifEQi[Bow@OgiSU¥S_McQaRVWgD}kK_Uik½[QYP_Be[YuK{uI[eIuWBCp`kGo[MmF¡ess¯OuW½i}DqR¡HaYFk[}uauQgBsMue]oE¦yÂNZYxyrAvhDr^`@[h@ÊcK¹``HPngpjpLbnrFj~I@z`VN"]
            ],
            "encodeOffsets": [
                [
                    [111544, 10805]
                ],
                [
                    [110123, 11633]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@Ê|{dp]NdĔ½žĉWGiysh_Ri`BqO~apJhanA[\\RvyAsck_©[qg§_w¿ËyYMmS¡§UaB]gmû{cS]DgSĉg¡GST§ZbKtfdvQ¢haXGhLxdkiH\\¶J²AÆPĈEºNtTìA¦PÔ@¶Hº"],
            "encodeOffsets": [
                [107352, 9760]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@n~\\@XGpÀhb]¨Ph^fgv[¾³b{Jivc¤¬¼íuc¡Q¡`W[UiF[\\se¢WM}ÉŏļWxgCon£JP"],
            "encodeOffsets": [
                [107757, 10454]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@^uImdSVPjWz\\e¬ABgdGglw|WFc¨bXWn\\SR|GlÖL_RdYIzwhlrAZUdVdafjR^RdKºh@j`hjE\\mbKv^¡tg`x`SlJZ]I]°FS Fd]a}qKqW¿CuLowGcW{Fw~[CSwAqeFweRmM]qE]i{HGW·b_edF`al]E\\oSoOyKZgRa]HS^KtzAaHMiN_dWÉgHe}£rIsNkzOv}dNV[lVphmzPPgjsQm]{L_suDmg]oBWZfWZ]¤gDY`jW^sPpQXX@ZCArnHNvGb\\VpBfVCTHd`tDl¦VR"],
            "encodeOffsets": [
                [108092, 23687]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@xhhN@Z°WZlhLZWrJVShJ_fvUf\\|ZdOXGu~Y¨HrkxGchwHVSfF`iIeNo\\cxeOgNklkO{pCYrRlkF\\WpACa{xM©NmtHkC]hmxAQT^JwMYV[sXm\\UEg]_eDYWEg|eBwgoHUcodWWy³}jwOE_D·bBqSaD{egQyYhaBQcmAczkUQggCGcqYuC}Zi[YimWkLeokaoRUWd¡[MR_vUzev_BYpgFkXqKG\\aLcpArgzLnnjr@`RVrEnDcdNflG|SJBtaxPjafVP[TEfRfYXwYgeAaL·J¥^{O@Klwn_|YRMhVfczLj\\VYtHv¬Ť°Ŏ"],
            "encodeOffsets": [
                [110186, 13622]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@rA|HTKxLnQvC[w`FZjffn@¤ĄclxSnJ]zBtXXoRXOf@¦ @|P¦]¸IbKBhfxZZWQeFe\\SOUbeOibwAsTIH{kMedcC FmUq_Qq@miKmhyBqdobKH[rLlWhEZo`AfuVy`uAm]WH·AO[iCOc@iia¦wVnsPhK`up[QeQJí¡ezagdZ[nB{UIYStWrL`aPQDW_s}UWwY@wa}iTKg{Ha_wdFz`XbªgPKp_zydGj_k`ViAiTWvBIÆiŐ"],
            "encodeOffsets": [
                [109780, 12592]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@@QQK}U_]INutQ^FpD~tN\\e|Sp^\\iÍq]BMqL{Ï]SmRyOj_AOmsZ_myd{mgRGU|LdtpApkp@zgoD{^IHv~F^JKxNVf^avQ^Jfjvi¸YD¦f~N"],
            "encodeOffsets": [
                [110792, 16598]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@v³X_~]LUK^G`q«XwrcdBR`^@tk`KAjkSlcRN¨kV]AqYuNr]dk|D\\XnEbF]wPejGTvrF^OlZEIZZ~fMXiDK~gW`NanTnR@Zxx²F\\ub³^edAbs_ithON]e[I\\vYhLqKm\\QjRwCi[MWo_OdgWs_YWsE}oGa[uR{]uoIwTaQ}DI{fUHcvUe{|]IRoM@¡JQGgC_gTkGYd}B_CRqfaJoW_`wYc`[FoQ\\}_}F¡dcSqJaOKiR@vYVYepIlBfJjObgXTZkpsFN^F¤e`X_QkA[bNOzR|CnplX©kN¬lBLpfn|nCPMnJ^OrPA_`¥WYKSohAJ~QEK[RwBLi{iswkQHCkbMWr@r\\x[jFdQr~VhOleH·kLu~JdzVWXsL[hqZWuVg@IlodsB@hklUMsVQtkA[xBfmJfJds¶Yf`|HdM@p[NVi^Fbhxpf"],
            "encodeOffsets": [
                [104780, 23089]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@oJO`tH^l`iTXtRMpJ^uxavLbXjthPIbXfIn@itqFMf`RMl`F@x`nG\\\\K```N^lNHbfLnWbJ\\fjRìbîjtPfYEeJw\\gKg}mngl`\\WEabCM_U@yJ}EimqKaiohoOm_G_ºLd@É\\g@]_qgCeG]rYE[\\q{uW[mgYYmHwSc`J^I´¥BeNsI@buOsmc@FKo£JoTkmcC_m\\£^{oWM]tnejAtjrpTrp]XHQl^\\C\\qtEUn"],
            "encodeOffsets": [
                [109405, 11161]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@ªevHÎTJ¨lfvfclTtU`}Îx±WOƴƙxIv_ÚċC@çñ_yHL½bUMh_aYZglaP_MeQM{«KaNuSUcfgP¿COudIja|½´u\\ehQR\\jvhHZJVlfIE¦]cjs^w[hsEmduNo¬OVMNKwN@XjXF\\TG{FSj}E®"],
            "encodeOffsets": [
                [107712, 11174]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@XX@hdPnp^BG|rPEXv`ddQ^XRhN²KrflVK[pnrWrEv\\T¦H`HX_l`LvvhGV^PPh~n~EZ\\NLZHnIlJI^DZjSn[\\CdbhxC^wtaªU\\Fl`VZEkFcX[jVNeGyZmGmqJIp«Co^©\\aIijJGnZWLm^grcIaXue·LZOPsncDsG[VQ_L_eWLl£RoGYXyBa_gJYcGkeSURinM®TdAJ~}\\{h]EMi[Q@ga[mOL½_iAUeoB[XEklqQZoDP|klMlhPwf[dMpJf_jeEUTGgxdwHql§G}ZvHWcP{Ye[uVe`gIUTqIYXKkgYX¯@YgMwgrÄOŖErĄEg]gJmbTnKXdve\\bt@xU@"],
            "encodeOffsets": [
                [110040, 14256]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@XehEvVVrf^¤dtlRljxX`zFne^VSDjR\\¦z^Fzra`ExcfHTM¦UX@ClLLn_fXUfNL^tL~@NUZXhzKT[~VrElzBHbzuBkTafSf`¢¥l~W|oPyQQUQ¥Ck_sGcSDeUoA[UHaMumGBqD@YWRWotOX]iZ_hC^£XYYeXW_SF]fRBcwkBU~»d[`LqXguvI[s]N][kPiV}a\\oWiaW^oUOBhm_gFkma¢[T{GWZcAkbElYWw]EtuG}eu_G]b_cY©GKb}ZJxOPMXDZkwD]oM]PE|hR^bYrZjsHMznc^mHern}hSfgNXAEuN[Vq¤Km`Ln"],
            "encodeOffsets": [
                [106846, 23257]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@OlpC_g"],
                ["@@lHRWxPNtvN[pPLjkCHlSrIlPMFZQVKxaL]hRZ¤T^QtN[OhBtmF»cDYh{nQ]u[Z_`KieZgskGm§yYHqBUZigPQe¡PUcnJdapvbzSV"],
                ["@@XmuE]n|F"],
                ["@@¨i\\`dHtG¤Tl]GkGh]]}YRwsVQFwV{f]O"]
            ],
            "encodeOffsets": [
                [
                    [109702, 21241]
                ],
                [
                    [108962, 21226]
                ],
                [
                    [109440, 21316]
                ],
                [
                    [109555, 21241]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@tFNtVVF~ttf]hCdRprpLDwV``TpbI`eENcnk`EhZrDTUHtQZcV½SUwIKtsD[OA]TLYqamHBt{G[kuQVwJ®KMX£u®"],
            "encodeOffsets": [
                [108308, 21059]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@Fk\\kR|c|EH²`EfBfXKf_lCnXQjv\\PxºbtWpFDdWfARm^@L^u_RgQWb[KWX¹bu]nHjwayCeqC]Q@_oMoPUkVaEe[ugH_g]KmdtK^UE£Pi|HSo__UCxoKoqcQgDe^ssE}UUMssEw@MnotFª¦A|NL[xPdTQQ@NNb`HTbEjshr¤§F_SÑuqJAXMJYTUpDd¤f|^VjZ¶hiJe"],
            "encodeOffsets": [
                [107975, 21776]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@rIbUZ`n\\HV]rIziCjV¸dtF\\W`¬CL\\xJhU\\Xj@hdAtbbNp\\V`GxRsºA\\l\\\\KfãzÛÁ¶ÝlBpx°¿¬hWBt]¤dA°»²|QzHh¯h¡aUyGMVıNgGkyN[yMo`¥MkQûf\\DbpmxsBKq~WOoTmm«MUQsbgBQu__Á@UAgjDHzIhchm@ArahgRR^UdYKQgaHY}T[jY@cdX¨k\\UWBAfYn§nCxegGW|gDczT¤DtpGrjvS"],
            "encodeOffsets": [
                [107712, 19051]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@~ÊXN¡tf\\[jEVX\\¢_¢RvdfYiiYÃ]HKS«Åå§wuacH_[_P}ySVK[QLeZEeYMVFfnPP|ÉrUrzXhLQdvIlrNÆEPlMN"],
            "encodeOffsets": [
                [108066, 10158]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@TbeªMwtW}Nvw``~Z kbHVWYpINBWrIvÒ`T¨Eq£tgFiSa_GMaM@RRSOc\\wMKB{¥E©psNm@xv­¤NWLQ~QBN{{RDXu\\Ue|ÁoQY]aFy|½SS}HEq^T{YgLùaZiHRjwrSty\\ESlmTveJMQ[mDsbJJfM|U^tYDeOVF¢InP`^fI~g~GdWBTXm\\^h\\mXFs C\\tcytY[P_^LRn\\"],
            "encodeOffsets": [
                [107430, 21619]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@²bG^ZZ@vvÖTbnUvBjkEvwAH{lMEiXShDL©OPcEqZWfRGhyNrVmFrsD[][RkWG^qooSiqBsfim^sNpX|¤]n[D`ndf[g\\c_{aAgYBcUikRUKJ{{ÛcBG~±mWj¢wXhG¢HZmXGd\\nSboR]WBw[IjgVuOyT@t]B_UMmZov|ĤãGan"],
            "encodeOffsets": [
                [108910, 11256]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@zOl^tWbTkPonSQkNWeYTaK}WWX{EaV_b@\\g]XjejCs_iZeWe^]biQMqCgY_FmlMdF_faJ{GOjF¤]VsLcLnh^G`h\\vFfUbVlpOpN@`^RrD"],
            "encodeOffsets": [
                [108546, 21505]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@_I[`pOfmBGjbPrWbLlQBcVWLqV["],
                ["@@`CfVlDUOcPKGTuZET"],
                ["@@hjt`~TfQHbbXVvnandNz@fatrMbTdIpXrjnsqKQ]Fwj³Ï`IQDeMCtaHOphHEWFQBljJRvm@wCG{S@¹ÁwQas@_]QIeXuQo\\M^hZ_KTR@{QRkrIpiKSOSdAb_pqrzu{J[[ELsOQyISJwZ]IQWl_S{_ICuVt¥n}hMD[KDwfmWekDaby@X¸uBmwiU_NWAmbg^@ZdBD^MÛKsXUtqQleboKVXEneJcdq¢SHt·ZgzXxmx@ÂiRC|TbAra¸CF`xP~i´XzcXdpGVhpAx{fFhZXfC^`Fh[VnW\\t"]
            ],
            "encodeOffsets": [
                [
                    [112039, 12858]
                ],
                [
                    [111863, 12513]
                ],
                [
                    [111611, 13012]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@IdT`f[og"],
                ["@@`iKP{IJqMomO[iNYapaOaMiRcvKeøe¸cfUnsLSToLSlY |@°[\\V\\bLLxZZnEf{\\Aps"],
                ["@@qPtljMQiYC"],
                ["@@Ahgz½«Ŏ}dMĜ¿äÏttIO¤pmhDXwŐĻNMkFOÅqMJkuRcgKyWVqÊqO{mOEekCUXBmd@qTazuFW_cKMFaA_ŽĊē¾Mc^co{|ÉRĖR¾rĔj¤CbL ®fNF{¼éðA¯YyX«âXwIo­HcYÊUfmlaBY¢ONp[vNhsbfRpXJn¸DDV E¼gpB"]
            ],
            "encodeOffsets": [
                [
                    [105963, 9510]
                ],
                [
                    [106561, 10641]
                ],
                [
                    [107149, 10029]
                ],
                [
                    [107294, 10771]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@\\Bp}B§nJ@RbPpeÎWrHfcph\\En¤gH[]Yuq]fjavF~S`ohCL]¼VVbU@xzT}hB\\WV}h]JsdKxyXbeQ|uRXmXGZyYsgm`[yBiAj_UEk[©Vsb]xwDagDc\\[TmiCYJ]kImJGKYMY[}F}mOg]OUgHuuKk_W`_G¥G[SFuqqXom\\LUekLqM±Qg]WcR_cWuFqOH{]AmocO@gWWMRD¦o\\GipBÐmpKjªhVZO\\T`G]vnjhZlFDp`|BttÀSS|D®qx^b_teblZxrIz`QjoBwzU~NjAnhnTi\\nt@otfYhXRg¢@jfVJbM^GRpgBft"],
            "encodeOffsets": [
                [110208, 15785]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@²õ}bsqD]jWfPÈJhPuB`cgsrQotAa^g`MMcrQtylENKw^cBXaQ[|}]OUqcck^wWI¯~w`{gsGIqX]aO_P]agL_^[|cDysRDn@q^r°aL@fmfJhmRKzWXe@n©dgI[[BgakgPs`jatcB]fa´[v±Eww@YmQSbm_MX}hLCWjeNY}JYFkY]PqESuiHOfxE^amF[W{Clcq^MZvBrU^§lQMdkTilB_Lsl]@Q_cAqdWx¬_r]HVLK}^W`u´BT~RQ`vTIn_rtJxbRrZNKh~zxA´³Dav¢\\¢d@XelEBeBcdgEyd_A]voDeWpBF[k¤PObhNhnd@thkpNdtFHT`^VLtCxEpbDMhcdEP]pU[K_tsNas"],
            "encodeOffsets": [
                [106015, 23136]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@xcb`|GhLjS~xbZ@Xx~V`tCXRbOK_XqsZTJ|VA\\mYhc bfyî¢RI Rfo\\_vgLOmtU¥xjb@jPdjDP\\¸BXGn^BNQ¢\\cVXpQlbfplKnXZjj\\~YvDrZHdhDRhlVdynBRdbAgzZRfhjQ@ÁnwWwhy_Aa]OlwZck[@ogmFUmA§mYSubSKEp]Fa{YAãukBSWC{jmVoagQgsSpoUIYZaoCMjeFa]BibhBXw©«u[U_kQU_Ç]_s[DyUjD^[rCxËr«XģR·IYIKggiDgZPS@skaDFb[Xk_mh~nLh[hxIFfeZsOoL]R\\EhbKnfBtdb¨ZdbhE"],
            "encodeOffsets": [
                [109969, 12050]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@VPL W¬Evr\\Gt¤ª¨Yv`\\TCXrUlb|PzppT[^FbkE_fc`¸aXH|G^jrF`Ai[Y¼_bNnMTlgPÍcQOarIfgIQYV{okAapYfNDtLbQv}´RUXHhfHR[hNTpIsJoU[ePWl@h]`@ncVqt]vC`rZÃXQN{OQLUePcI_yiASY}FWWveLsT]OmFqpS}]IcjS]W×VE__Y_DYgcEJ^Mrbf_j_LilTjUbkRoEGffRaAg\\KAukJ|FfqT¿JqSgHeYqOqYU^owaWcWFi[Vc]F_ZPvMZiKkRDYLO×zHê\\NZ`IzZ¹t{nYhqGGlYbXXPBr`nl"],
            "encodeOffsets": [
                [108645, 22465]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@dhJnhLPj_Zl^Zd~jSHaq\\q^H¢­Vk{hoVLxzU^ax\\nFFÌb¨SrrÊ^`jP`zplnKx`nFÔrXKk½nrWfDjiKmn_Lr£\\UvMFBWhMTe~gqmfnGd]mNytGYiZq]agQF{^OpNCqz@JAI±arKXpslKf\\yw^mDkq³d¹CqAWoonIh©`iA`Rs@k[µRURVaWXDgnIv{~R\\WbA]dLxMkFszqRNd_N]hBbspqRht_dAvgOÇIeOiXC^rat~±ö"],
            "encodeOffsets": [
                [106015, 23136]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@CŌz^lfjLJx·ta¦gIKj¶jEÔHpkCªqmzZxQjDH]¬^hRK\\\\_d|\\tSqbmHä{ģpunYVN`^A@szSvPhUJix\\XA^pQTa[mHcnWGYH¡Wgqig}YMcVAt_P_}}_QeaM]\\yPgKUW_Y\\uBAhxhWZt[_eXA|kZ@Vy~SIolçQUDýID«Ɖ\\DÙČu`wJƳƚXPw²Í_~"],
            "encodeOffsets": [
                [108031, 11217]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@zM^[_XiGfMDe{qHs\\EnXluOdWl{nWFd`rP|ur{LwWUrsL}gIOµ½ÅÃÏ¯ÍC_miOQrìn\\HzlKÀQQ[uX`XK\\GoZLlo|uX^dapUxvR\\l|HAsnGb ZrK^SB\\PtCLsxJTV"],
            "encodeOffsets": [
                [108732, 20977]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@^SBbaÆTOPnIZWx@ZQj£QWwFeuKwR}CyvsTVD¬\\ZnXWA{QWGR`Yzd^cFc«^T]dZXO^XERcÅpIX\\n}l[NibcrDvbz{VJ[m[WWOwMûg]\\gYuUµH}^±²qr{BeXqk[B[t¹wQ_H[UMoaaBsgci@[WgVwIK[«D_[XsE·ciUDyjqJU^Gm[Y_aVqJVYf_Ccn]PPdUXwS¯DPdLI\\ÝKGq^C_WaV¡ASdkQqTc`MdkAmRAV}^Qf£^gWVIl]XaCer[@SeuCunAXin@^}dk@jIjwPoSmH[\\VtoNi©N[dkNqfÃ]^ObcN[MUdXxPvl^EVZvTpOFbhDV\\edJXAi^q~LpSd`zgvChNN|CXzEnSdF`OLi|p¾ZVMHsfBbgxDb}hSbJrIZ\\~LjW`BB~pLr|HZEnxjZlKddCrVbWR^dM\\L ´H~"],
            "encodeOffsets": [
                [107425, 20479]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@~GTT¾z{bEZ^pR{ÂVfv[CW|QM|AR}R­Ibo]cvWp{KkpYHL[_WvW\\RRL¿kGym[qëRuamLEhwlRjNhC`£OuRCÍ®eFk`aJxPÅ]t}zyPatqHnM|"],
            "encodeOffsets": [
                [108075, 20853]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@¸YGsTr¡dcfIFmUWpLfa krRsVtWÜLOmrcAYhUEuq]}MgUOw_U^uK}LQYNycm@¯KwJgM{RkMGWwkIxgGRjeFYj·VyrH²BQKTg_½LUpinD|TXlAävZBb|Eo^FLaTTvnZB¨VnE hn@p\\dlYkx^PBb`"],
            "encodeOffsets": [
                [111342, 12454]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@JIXf`jodRalpF[h]F^ahH\\vRM^XCfppB\\XU|QxP[zÄiLUnA|qxEHW[cj[H£LupCfÃTqj`tkMTauRgWIfjgYµUi]e{£CcoVZSZoXGUal}Y__uxM~sXx©NafS_bnV°S^W@¦{t"],
            "encodeOffsets": [
                [107330, 21846]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@VfjB`K¾Pn\\hb@\\RNjFg^[|}~IBc­SmNQjVfTHlZdhIb`zAZWpHf¬LmCZxF¢dTZ¢ ^~mGqHotYgYsdEXY`QYXQq`SnsDc^eMaT`OK¥BHh\\rcUKNQE^MPo`SvRO£½]MHmYQP{OJi£p©¦Å¤ÓIwdsYUkmtqioWcJaSqNseby@cMmmbUuaWGaeR}Ss_giUNZIx]SRwBgnD^lsGMnªwN|Db"],
            "encodeOffsets": [
                [111291, 13310]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@Â@``RvhAtaRV¬NnnpSXPr}LtAnwoCa[üelR¦Np_zNM\\lzhHĲMNUzHbVfsW__Aaiq§B`¯ÅLe¯NIhxp «¨¥ªźĥ·­e_YoIPe[_aKeLYeB{oUKwHoQ·sg­D[jQ~kC[VweTqFWbeK]ZGtkj\\tOdgfTTynEg@}DLcgosEnaJ[xtȕɠc@Yj©x{KM¨[D@n{bqN~mpqLy^Bd^|@dfjB~"],
            "encodeOffsets": [
                [108179, 18425]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@j`rqIXVOjhZ¢P\\~Y^g|EhfA^nb^nWXFJ|]pCh@yloBosoKc{VHhQ|nzc`ntYPn`BPiznQ^T°toT«^}¨ëË°ÕklDb]RkIeuyM@egAkU_Dc]uF_a¡L_yELgaFsk_taUµgsAWc_DeqeL]CgA~yS@wVUa»UK^gD_p}TuEiber^Zv^ G\\£hm[FogedqGÍXofaOQ@mI¨Ao~[ACueXYZPfYcJqfNCWBUSdAnkLPp]nDWRAd[RVj@rOb]DIpMCfdv[hj\\MllzT¤tMnrf¤d~^"],
                ["@@aHmSIk^W|"]
            ],
            "encodeOffsets": [
                [
                    [110046, 16410]
                ],
                [
                    [111101, 16359]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@zWTL`pgIW\\qYqrlcrEBaY_kIW_DµJ\\³ęÇ|³³zPg]bßk\\_hBfyqR[Gqj}N]kR@mk­GLoCsUdW]§uWiiUW\\EdlYFiBAjz_\\hnZtYzWHWnQ{vRafWwzcLItg^U~[XDK^rfCfd`BXhtV¶sbl`EthbKzF`¢K`bvEd^`ClVhBf@Nvz"],
                ["@@kNA^Ckg"]
            ],
            "encodeOffsets": [
                [
                    [111349, 15769]
                ],
                [
                    [111740, 15738]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@CnjIec"],
                ["@@lZNcyJ"],
                ["@@V@cyqkLIRvH"],
                ["@@É{L^¼~B_"],
                ["@@@zhllGI]"],
                ["@@VxRFeW[oQeJ"],
                ["@@PfGUsqYkXXX"],
                ["@@V®PSe"],
                ["@@YW{CDZ~PTM"],
                ["@@QXmF]uV@@}"],
                ["@@fg[OUnml\\b\\QBq"],
                ["@@XSDmHWRD~xU"],
                ["@@@fvL`MassP"],
                ["@@JUOomaihB^~"],
                ["@@^ZHbvlCwo"],
                ["@@ZlzxzF[kJqYaa¥MOU«L¬V"],
                ["@@]CRT`Nx`a­W[S"],
                ["@@d|\\@KRZdE|XajDb]ZR¶h TlCoC{DOokO{QDbT"],
                ["@@xAbDT]jMFÀYäYtPN|xFNY´Pd_lhrRvWxVPNZvdFZh`C`ZF`ØU^XTdi^JT~oErPnS^KtufXX~ETZjB`zdJfOVjG\\nln¦rTCfwA{|_hA\\rtFVWfF´Eb|dÂdhE`YXTfGZX_ uT}vJ°F`goej]xAEWGwackSTh^almVqLKh©UyhsgPJefu]KiwU¥FONk@KcmkXaveuoYZu»uJMBi^ITgoRq]MNm@igkKyP£@eGMcu}U¡@hXfzPgXU[[@UWwBczqaVmKÕhIfcBJwRUGkPcemUVmaS`gPAg|CZdE¼sngAP\\sM]RSbuhEYMjyEcZTfInrA\\ZG`là"]
            ],
            "encodeOffsets": [
                [
                    [109981, 21278]
                ],
                [
                    [110539, 21746]
                ],
                [
                    [110521, 21901]
                ],
                [
                    [110389, 21849]
                ],
                [
                    [110445, 21530]
                ],
                [
                    [109956, 21729]
                ],
                [
                    [110119, 21601]
                ],
                [
                    [110238, 21649]
                ],
                [
                    [110161, 21781]
                ],
                [
                    [109958, 21293]
                ],
                [
                    [110347, 21493]
                ],
                [
                    [109484, 21445]
                ],
                [
                    [109924, 21368]
                ],
                [
                    [110103, 21420]
                ],
                [
                    [109981, 21421]
                ],
                [
                    [110071, 21493]
                ],
                [
                    [110161, 21487]
                ],
                [
                    [109978, 21601]
                ],
                [
                    [109058, 21734]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@\\UlDR}\\i®Cth¸RGpLxpVA|ZffKbL\\`OfpJ`Zf¸®¨ÌDIIJvÖÕÀ«à³eSe·J[de[[wuhwQaLKYKYg@wSgkZUxK~mVsY]Ny@SoRYBsuPKCLSiFUSDPGh\\snW~]\\`^QfPn@ofREwkWDQM@dUTAn[@F~abBfrlq]Co`uCNfsh[ª@ƜTzrHBÐ"],
            "encodeOffsets": [
                [109107, 17407]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@~z`O`\\dGbxvæ¨ÆT¬GL^ZÄjjtOºf}®­^ioÐÙÐ¿´UOUay]UKQwu^_Dos]AŅŭ±SNH[À`VTakcKa}\\[zoIyi@WZcKcpi@{`O[AhVĈQf"],
            "encodeOffsets": [
                [108080, 9817]
            ]
        }
    }, {
        "id": "826000",

        "properties": {
            "cp": [105.549, 21.19],
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@~E`[~pRE_\\Zd_x`pXbIreQDA`c~HZSl`hhDHIR@¢NQpJ{^f|uVGdeVJ|~CbRxSpJ^vQ|\\vbpHF~Xt`ZXtch`PXp\\NDjQxi[RLnKrguZ[Jf\\M^blAh\\\\hJªcmf@XWLynQIgne@ebKq¯r]@CmtQzdC\\{`]hK^b`ObP`UAi¸LI`Y]RFMprCîciycNigbs@oU}d]CclYXgnNdaVJkB_¬]tt¦IT\\´OXr~@zhMVibTfC|s@¥XT]U¯m`a[Qm]K`\\OZzsdsD[tEnWg[]n[SWAcX}H}heJ_]mOJE¡PUE@qQe~uCµªCfAeTChhyi}hU¤{ZE^mI[EGrotyh]FdcVyLMX¹QSncLWY[K]Q@mT[_¹LwekseViRk}uTkM_NcgYEDRcSOMaLOeBSb{^OXÅTwBOjejD`k`e]GcuFqYqn]Gy`oJIXUoTUdRhgt"],
            "encodeOffsets": [
                [105694, 21398]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@ď[eWOgUSWgEseefmSsjWGhMdAs¤wMUdYuÕ@uYYH]±arsT{[`c[[LgQ«]G^vK`LaCª[[cg~_@S^rIVGÓ`CHKPTP]VP`G`vnFf{bVjKtLpm@aBlb@r`uUvtFxjVZrKn\\pDpYpi^FnQdfoEbOH]xPz^~I`[O"],
            "encodeOffsets": [
                [109006, 11951]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "MultiPolygon",
            "coordinates": [
                ["@@[njbRU_y"],
                ["@@^fj[lVUVtbTUayuboIcmVd¢ORfhOjVYrA@e§@gSiPu^SE¿a»XÁakgX{vqOc_EmXk|cXPkvmW[FGt|rCfeNHWj`]\\yNU¾YdsRGSVRNaj^f]fXjY`t"]
            ],
            "encodeOffsets": [
                [
                    [109150, 20736]
                ],
                [
                    [108820, 21182]
                ]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@hRdrFp\\jFNdpOdc`BzYTqEc^_FiMmD]DWv_ZBLxl\\lC^|Npl@VDdbO\\gEk_mAqOWWZaHkrHZg|mºsYJyY_mjOmPmMi]Shka¹VY@aGD}MQ£^kKe}B[eBcXCoEXasQBYa`oEexu`uBinB^iVOpiXw[D_R}HTaK\\Td_zF¬FBdUpt`TdGNT"],
            "encodeOffsets": [
                [108090, 22485]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@¶©vDf}rR@FfZC sV]N{IeItanCR\\NfIunSTkFz[TsxqQijGbYúhK|ZSr]FN{mrGbszO~y^sÆOwbIl_fEÎ­DvQ¤PD_giMQµYWMPKcMwHyUqcR]UgYgíKB½Iue}H{Zp_eI\\Uy|uaqCadMjk\\m~W[oJÆQdF]WWPcY^]S¬Ed]dyc_ZQHRXB|WXm[Y«UCSutDzQ~LxfvxERXi¤YRw@YXmJOSPÅabA]TXd~p^Hd^buHEXn[l_QK^Q^z±FcVLM^Ea^C~VÊGhllhvPqiTEnY]WM@aOiJCg{Um]mT}CatRlwhUrljrHXV\\v|nHJp\\tXdGth\\x"],
            "encodeOffsets": [
                [107152, 21149]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@ĺĉĞÛVHc¦öÏæÓlW|uZNjqUjJ\\dN}¨Ýz_~RlYr@}M¥eC·Zujei]IuR]beMULw]IE}GuWEmXa]mB]ge{F]h}Z[¡OgYPiWUJqri_g\\A`^fO^sS_NYmkXWYwKvoa@s|cMuFpWtCxTU^¹[OLKTDOLvAtQZTpz@MZ^Ut}nwLYVhlxTh@LZZLbKxRvgx\\\\cfI\\¸ffT"],
            "encodeOffsets": [
                [109967, 17146]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@Ɗ[C¬þJVCèRpkTJz}@UlYB{fW\\`sXYwgBgvAZ[`VXhLzO^[bNRf~``~`OBsdUZNh~rjx¡XiWAåtaPiyp£hÁ^©ba\\rs@vPÓk[Tí_©uCwMj[G©}Kg`NaVK¾zG`èò@"],
            "encodeOffsets": [
                [108485, 10790]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@pJ O^NnhE\\hnO\\QHVd\\LdYxM|hJXp¨AvKkßH_[YqBJmSedYzFiZNFvgTa£SQY^gbKLwUYRENkOJTqGklDKioO\\uMMswOQXkGsaUUVki\\]eiDifW^[ha@U`FbW|XXL~SbfZMXRlmTOp"],
            "encodeOffsets": [
                [108675, 21488]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@|Ypkw´upiª«ÊăUoCi_oagUkLMKforyfUQ³ÏÀÏÚp]j­®e~Jf|^L`dI vkhrD¾bKPdkphAVrc"],
            "encodeOffsets": [
                [108841, 10291]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@`d^a`HfvH~sv^FXxkZFladBXY|H\\Sb¡nEl`hgnAVP]pbXXj[p~bUjO\\lM^t^J\\uhvrWK\\_¼cV}lAdxAQ^eETX`ACYhkFooZ{M]NguSyaQwBseUBcc_P]]e_JqMq~yCWW}TgSgr{NVgvqrUMSHScs_VoAcEE«`yc[SLbGS~`Qywe[Ha[Pq@cZcoDKv¤Gi\\\\dGXwF{rmBKVÃjgr\\zQRbx}¨[NOveFBgMW\\XS^N¥QOh©`mtAS`Ix"],
            "encodeOffsets": [
                [107366, 22718]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@DPÀhOdeTVvbM¬LN|RNfO`kbYhbZ~Lª\\HM_RlMAUnww­rqdUBogclOaLC½gqulcJK_{]Ie¹ sPeZ»î«£"],
            "encodeOffsets": [
                [108220, 10378]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@ ddYr@\\Ob\\Gxfz\\CxjWPojUA]jmvAv_fwpFb_ZRAw¹[OiuRmWkD`LeeWeAF±_G{F{dQ[lElXQhvSbNsli_SreÄ"],
            "encodeOffsets": [
                [107853, 22024]
            ]
        }
    }, {
        "type": "Feature",
        "properties": {
            "name": "越南"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": ["@@JuhmCWbXUVQ¶Q\\@lQt_jBª_JgpmpBXrDcºr´Cl]nzx[LetkoLWqbJ²BI y@DrC^lxYCNWOPIw~YLaªHZJwT_Bnsª_Pg¦RMT]WX[hNAfEPu\\M~§awRQ[yhq\\ywO{RWV[oAoDe]WNuQG[bgE]^\\gEobkcQipe_JWIeDaSUjgNy }@WqP³S[¥Jss«^A`lUIcbmMWhkZDdc^V~@patjhMzdjídDoqNEQ^_ZJ·KBj_VW^JrHht_|}xJ°xXl]ddVr^P"],
            "encodeOffsets": [
                [106482, 22495]
            ]
        }
    }],
    "UTF8Encoding": true
});